function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchIlustration = function SvgSearchIlustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 666.88,
    height: 566.667,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4041.93 1183.13 2046.01 2327.8c-46.83 27.02-108.7 42.53-169.77 42.53-51.37 0-98.86-11.08-133.75-31.22l-917.873-529.93H697.234v-132.54c0-43.49 29.852-85.69 82-115.81L2804.32 399.441c46.82-27.031 108.7-42.531 169.75-42.531 51.36 0 98.87 11.09 133.76 31.231l982.92 567.48c40.2 23.219 62.35 56.949 62.35 94.979v132.53h-111.17",
    style: {
      fill: "#2c1d1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2974.07 489.441c-61.05 0-122.93 15.508-169.75 42.539L779.234 1693.36c-52.148 30.13-82 72.33-82 115.82 0 38.03 22.133 71.76 62.344 94.98l982.912 567.49c34.89 20.14 82.38 31.22 133.75 31.22 61.07 0 122.94-15.51 169.77-42.54l2025.08-1161.38c52.14-30.11 82-72.31 82-115.82 0-38.03-22.14-71.75-62.34-94.97l-982.92-567.48c-34.89-20.141-82.4-31.239-133.76-31.239",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3092.47 547.301 982.91 567.489c69.63 40.2 60.82 111.07-19.58 157.49L2030.64 2433.71c-80.4 46.42-203.15 51.51-272.78 11.31l-982.919-567.49c-69.628-40.2-60.82-111.07 19.582-157.49L2819.68 558.609c80.4-46.418 203.15-51.507 272.79-11.308",
    style: {
      fill: "#593d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4037.84 1261.91 2848.4 575.191 827.188 1737.01l1189.442 686.72 2021.21-1161.82M1321.7 2136.86c-22.54 0-40.81-10.96-40.81-24.48s18.27-24.49 40.81-24.49c22.54 0 40.81 10.97 40.81 24.49 0 13.52-18.27 24.48-40.81 24.48M1439.57 2200.74c-16.23 0-29.4-7.9-29.4-17.64s13.17-17.64 29.4-17.64c16.24 0 29.4 7.9 29.4 17.64s-13.16 17.64-29.4 17.64M3461.42 795.121c-15.3 0-30.29 3.789-42.21 10.668-14.79 8.563-23.27 21.191-23.27 34.691 0 12.192 6.93 23.161 19.03 30.149l180.17 105.062c9.35 5.391 21.27 8.239 34.46 8.239 15.31 0 30.32-3.801 42.25-10.692 14.78-8.547 23.26-21.179 23.26-34.668 0-12.179-6.93-23.179-19.04-30.16l-180.18-105.051c-9.33-5.379-21.25-8.238-34.47-8.238",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2944.32 1631.41c0 61.26-37.24 132.42-83.19 158.95-11.61 6.71-25.39 10.14-36.34 10.12-8.59-.02-30.54-.85-53.31-14.93-26.17-16.18-29.7-52.93-29.7-52.93l93.46-191.97s30.1-14.78 61.02 2.16c19.24 10.53 30.85 27.94 36.14 37.58 2.33 4.23 5.83 12.75 6.89 15.96 3.25 9.97 5.03 21.71 5.03 35.06",
    style: {
      fill: "#2c1d1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2739 1705.75c0-61.26 37.25-132.43 83.19-158.95 45.94-26.53 83.19 1.63 83.19 62.88 0 61.27-37.25 132.43-83.19 158.96-45.94 26.52-83.19-1.63-83.19-62.89",
    style: {
      fill: "#422c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2770.8 1681.55c0-33.56 20.4-72.54 45.57-87.07 25.17-14.53 45.56.89 45.56 34.45 0 33.55-20.39 72.54-45.56 87.07-25.17 14.53-45.57-.89-45.57-34.45",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2778.82 1666.44c0-19.95 12.14-43.14 27.11-51.79 14.96-8.63 27.1.54 27.1 20.49 0 19.97-12.14 43.15-27.1 51.8-14.97 8.64-27.11-.54-27.11-20.5",
    style: {
      fill: "#422c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2784.08 1650.79c-7.43 26.05-11.81 70.22-10.72 108.35 1.09 38.13 14.25 58.71 64.89 50.39 40.79-6.71 89.81-51.92 106.84-107.54 7.42-24.26 9.53-29.9-26.3-44.27-28.94-11.61-120.72-55.93-134.71-6.93",
    style: {
      fill: "#c4b3b1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2049.49 1431.84-10.36 17.76 596.62 348.06 10.37-17.76-596.63-348.06M1845.56 1557.27l-10.37 17.76 596.65 348.06 10.36-17.76-596.64-348.06M1619.98 1668.58l-10.37 17.76 596.63 348.07 10.37-17.76-596.63-348.07M1416.06 1794.01l-10.37 17.76 596.64 348.07 10.37-17.76-596.64-348.07",
    style: {
      fill: "#d8c4c3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2792.98 1731.59-1117.31 645.05-8.39 5.25-5.57-8.2c-3.37-4.96-7.03-9.73-10.98-14.32l-5.54-10.89 1128.04-651.1c40.72-23.51 64.06-53.39 64.06-81.96 0-22.19-15.02-43.1-42.3-58.87l-325.77-188.09c-72.08-41.58-199.2-35.96-283.4 12.56l-974.13 562.46c-7.76-10.39-15.45-20.81-23.37-31.1l977.73-565.53c49.85-28.79 115.97-45.3 181.4-45.3 54.67 0 104.94 11.63 141.52 32.75l325.77 188.08c40.03 23.1 62.07 56.15 62.07 93.04 0 43.06-30.56 85.39-83.83 116.17",
    style: {
      fill: "#d8c4c3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2989.03 2081.23-565-326.2c-63.93-36.91-176.64-32.24-250.46 10.38l-1068.82 617.08c-73.82 42.62-81.91 107.7-17.98 144.61l565 326.2c63.93 36.91 176.63 32.24 250.45-10.38l1068.83-617.09c73.82-42.62 81.91-107.69 17.98-144.6",
    style: {
      fill: "#c4b3b1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.52 2868.15c-38.9 0-75.99-7.81-103.6-23.76l-565.01-326.2c-24.5-14.14-37.98-33.26-37.98-53.85 0-25.82 20.4-52.4 55.96-72.93L2178.7 1774.3c71.2-41.08 178.93-45.71 240.18-10.38l565.01 326.21c24.5 14.14 37.98 33.27 37.98 53.84 0 25.83-20.39 52.41-55.97 72.96l-1068.81 617.08c-39.07 22.56-89.19 34.14-136.57 34.14zm554.77-1148.22c-51.15 0-104.96 12.37-146.87 36.58l-1068.81 617.08c-42.11 24.3-66.25 57.38-66.25 90.75 0 28.24 17.14 53.69 48.27 71.67l565 326.19c66.94 38.66 183.91 33.97 260.74-10.37l1068.82-617.1c42.11-24.31 66.25-57.39 66.25-90.76 0-28.23-17.13-53.68-48.27-71.63l-565.01-326.22c-30.43-17.58-71.21-26.19-113.87-26.19",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.2 3811.69c-43.12 65.09-118.72 52.14-169.39 22.89l-120.5-68.12c4.57-7.98 9.06-16.01 13.41-24.12l120.89 68.34c41.56 24.02 103.79 29.99 136.61-19.93l905.01-1279.93 23.95 13.9-909.98 1286.97",
    style: {
      fill: "#d8c4c3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160.65 3104.58-50.76 29.31c-35.56 20.54-55.96 47.11-55.96 72.93 0 20.59 13.48 39.71 37.98 53.86l68.74 39.68v23.77l-79.02-45.64c-31.13-17.98-48.27-43.43-48.27-71.66 0-33.37 24.14-66.44 66.25-90.76l61.04-35.25v23.76",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2976.19 2977.23-1068.82 617.08c-76.83 44.37-193.8 49.05-260.74 10.39l-464.7-268.3v-23.76l474.99 274.24c27.61 15.95 64.68 23.76 103.61 23.76 47.37 0 97.49-11.58 136.56-34.15l1068.81-617.08c35.58-20.53 55.97-47.11 55.97-72.93 0-20.59-13.48-39.72-37.98-53.86l-525.21-303.22v-23.76l535.49 309.17c31.14 17.96 48.27 43.42 48.27 71.67 0 33.37-24.14 66.44-66.25 90.75",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160.65 2906.42-50.76 29.31c-35.56 20.54-55.96 47.11-55.96 72.93 0 20.59 13.48 39.71 37.98 53.85l68.74 39.69v23.76l-79.02-45.63c-31.13-17.98-48.27-43.43-48.27-71.66 0-33.37 24.14-66.45 66.25-90.76l61.04-35.25v23.76",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2976.19 2779.07-1068.82 617.08c-76.87 44.38-193.85 48.99-260.74 10.39l-464.7-268.3v-23.75l474.99 274.23c27.61 15.95 64.68 23.76 103.59 23.76 47.39 0 97.49-11.58 136.58-34.15l1068.81-617.08c35.58-20.54 55.97-47.13 55.97-72.94 0-20.58-13.48-39.7-37.98-53.85l-525.21-303.23v-23.74l535.49 309.16c31.14 17.96 48.27 43.42 48.27 71.66 0 33.36-24.14 66.44-66.25 90.76",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1160.65 2708.26-50.76 29.31c-35.56 20.53-55.96 47.11-55.96 72.93 0 20.58 13.48 39.71 37.98 53.85l68.74 39.69v23.75l-79.02-45.62c-31.13-17.98-48.27-43.43-48.27-71.67 0-33.37 24.14-66.44 66.25-90.75l61.04-35.25v23.76",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2976.19 2580.9-1068.82 617.09c-76.83 44.35-193.8 49.04-260.74 10.37l-464.7-268.28v-23.75l474.99 274.22c27.61 15.95 64.7 23.76 103.61 23.76 47.37 0 97.49-11.58 136.56-34.14l1068.81-617.09c35.58-20.53 55.97-47.11 55.97-72.93 0-20.58-13.48-39.71-37.98-53.85l-525.21-303.24v-23.74l535.49 309.16c31.14 17.97 48.27 43.42 48.27 71.67 0 33.37-24.14 66.44-66.25 90.75",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2976.19 2382.74-1068.82 617.09c-76.83 44.36-193.8 49.02-260.74 10.38l-464.7-268.3v-23.76l474.99 274.23c27.61 15.95 64.7 23.77 103.61 23.77 47.37 0 97.49-11.58 136.56-34.14l1068.81-617.09c35.58-20.53 55.97-47.12 55.97-72.92 0-20.59-13.48-39.72-37.98-53.88l-525.21-303.21v-23.74l535.49 309.16c31.14 17.97 48.27 43.42 48.27 71.67 0 33.36-24.14 66.43-66.25 90.74",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1639.92 2846.93h-20.57v742.49h20.57v-742.49M1479.03 2760.31h-20.56v729.81h20.56v-729.81M1315.73 2657.45h-20.57v742.48h20.57v-742.48M1152.43 2567.24h-20.57v742.49h20.57v-742.49M1982.41 2798.57h-20.58v742.5h20.58v-742.5M1811.15 2877h-20.57v742.49h20.57V2877M2145.7 2708.28h-20.57v729.94h20.57v-729.94M2309.02 2616.82h-20.57v742.48h20.57v-742.48M2472.32 2513.97h-20.57v742.48h20.57v-742.48M2633.2 2427.33h-20.57v742.5h20.57v-742.5M2796.5 2324.48h-20.57v742.49h20.57v-742.49M2959.82 2234.27h-20.57v742.49h20.57v-742.49",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1579.96 3372.13v-734.57c0-59.36 85.51-107.49 191-107.49 105.48 0 190.99 48.13 190.99 107.49v734.57h-381.99",
    style: {
      fill: "#d7c3be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.96 3197.98c-105.49 0-191 48.13-191 107.5v-560.42c0-59.36 85.51-107.49 191-107.49 105.48 0 190.99 48.13 190.99 107.49v560.42c0-59.37-85.51-107.5-190.99-107.5",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1943.58 3429.71c-28.15 61.95-80.45 138.62-80.45 138.62l-183.58-1s-81.43-114.67-97.64-176.68c-.47-1.83-.15-3.27-.26-4.93-1-4.46-1.69-8.97-1.69-13.59 0-59.37 85.51-107.49 191-107.49 105.48 0 190.99 48.12 190.99 107.49 0 9.17-13.38 46.6-18.37 57.58",
    style: {
      fill: "#eeded9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1866.46 3555.1c0-29.69-42.76-53.75-95.5-53.75s-95.5 24.06-95.5 53.75c0 29.68 42.76 53.75 95.5 53.75s95.5-24.07 95.5-53.75",
    style: {
      fill: "#fff6f3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1831.8 3568.33c0-18.91-27.24-34.24-60.84-34.24-33.6 0-60.84 15.33-60.84 34.24 0 18.92 27.24 34.25 60.84 34.25 33.6 0 60.84-15.33 60.84-34.25",
    style: {
      fill: "#d7c3be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.01 3677.88H1686.9v-70.65c0-9.03 4.73-17.37 12.51-24.53v41.19c0 2.94 2.41 5.35 5.35 5.35 2.95 0 5.36-2.41 5.36-5.35v-49.16c6.09-3.61 13.25-6.56 21.09-8.95v45.26c0 2.95 2.41 5.35 5.36 5.35s5.36-2.4 5.36-5.35v-48.06c7.84-1.62 16.2-2.59 24.95-2.84v47.51c0 2.94 2.41 5.35 5.36 5.35 2.94 0 5.35-2.41 5.35-5.35v-47.36c8.74.39 17.18 1.36 24.96 3.15v47.6c0 2.95 2.41 5.35 5.36 5.35 2.94 0 5.35-2.4 5.35-5.35v-44.47c6.84 2.25 13.11 4.95 18.54 8.16v49.16c0 2.94 2.41 5.35 5.35 5.35 2.95 0 5.36-2.41 5.36-5.35v-41.19c7.78 7.16 12.5 15.5 12.5 24.53v70.65",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.76 3629.24c-2.94 0-5.35-2.41-5.35-5.35v-41.19a62.92 62.92 0 0 1 10.71-7.97v49.16c0 2.94-2.41 5.35-5.36 5.35M1837.15 3629.24c-2.94 0-5.35-2.41-5.35-5.35v-49.16c4.08 2.42 7.6 5.1 10.71 7.97v41.19c0 2.94-2.41 5.35-5.36 5.35M1736.57 3616.39c-2.95 0-5.36-2.4-5.36-5.35v-45.26c3.46-1.05 6.98-2.01 10.72-2.8v48.06c0 2.95-2.41 5.35-5.36 5.35M1772.24 3613c-2.95 0-5.36-2.41-5.36-5.35v-47.51c1.38-.03 2.68-.23 4.08-.23 2.27 0 4.41.28 6.63.38v47.36c0 2.94-2.41 5.35-5.35 5.35M1807.91 3616.39c-2.95 0-5.36-2.4-5.36-5.35v-47.6c3.76.86 7.25 1.98 10.71 3.13v44.47c0 2.95-2.41 5.35-5.35 5.35",
    style: {
      fill: "#472d32",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1855.01 3677.88c0-26.13-37.63-47.31-84.05-47.31-46.42 0-84.06 21.18-84.06 47.31 0 26.13 37.64 47.31 84.06 47.31s84.05-21.18 84.05-47.31",
    style: {
      fill: "#604047",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1828.17 2683.81c-30.97 22.23-41.48 59.11-41.69 96.61-.1 16.65 4.05 32.67-.03 49.15-5.53 22.42-23.34 42.24-47.68 30.16-11.93-5.92-19.66-15.18-24.35-26.14 2.31 30.73 14.6 64.39 7.75 93.04-9.23 38.61-46.83 35.51-71.17 9.66-68.18-72.4-14.61-204.42 70.42-238.22 43.06-17.12 85.15-23.77 106.75-14.26M1656.83 3131.07c2.76-8.9 5.56-17.6 8.44-26.09 2.87-8.49 5.8-17.03 8.8-25.65 2.03 2.55 3.87 5.34 5.48 8.4 1.61 3.04 3.19 6.19 4.76 9.39 1.56 3.2 3.09 6.42 4.61 9.66 1.51 3.23 3.61 8.51 5.03 9.22 2.58 1.29 12.38-.93 19.26-1.26 6.88-.36 13.47-.96 19.72-1.85.45-18.43.45-37.65 0-57.65-.43-20.01 2.63-56.38-.66-59.68-.59-.59-5.98.08-9.38.29-3.39.2-6.9.52-10.5.97-3.6.45-7.22 1.07-10.87 1.86-3.65.78-7.14 1.75-10.49 2.85-.11 3.9-.09 7.62.08 11.2.16 3.56.33 7.1.48 10.61.17 3.5.33 7.07.5 10.68.15 3.62.18 7.38.07 11.27-2.06-1.23-3.86-2.77-5.43-4.58-1.57-1.82-3.07-3.7-4.52-5.62a65.986 65.986 0 0 0-4.6-5.46c-1.61-1.7-3.54-2.98-5.78-3.82a61.109 61.109 0 0 0-4.25 8.3c-1.23 2.9-2.45 5.84-3.67 8.81-1.22 2.97-2.44 5.89-3.66 8.77-1.23 2.88-2.57 5.71-4.05 8.48-.32-3.43-.43-7.16-.32-11.18.11-4.01.21-8.11.32-12.28.1-4.17.15-8.3.15-12.39s-.2-7.89-.62-11.4c-6.35 1.57-12.71 3.49-19.1 5.77-6.4 2.27-12.95 5.14-19.68 8.65 0 9.35.05 19.01.15 28.96.11 9.95.28 19.88.54 29.82.25 9.92.51 19.77.76 29.54.25 9.76.49 19.16.7 28.19 5.61-1.61 11.69-3.77 18.3-6.39 6.6-2.62 13.09-4.74 19.43-6.39M1781.23 3067.91c.55-12.46.61-25.25.16-38.38-.45-13.12-1.1-25.77-1.98-37.95-2.87.03-5.78-.02-8.7-.17-2.93-.17-5.88-.26-8.86-.29-2.99-.03-5.93.03-8.85.18-2.93.15-5.76.55-8.52 1.18-.55 12.52-.85 25.15-.9 37.9a986.53 986.53 0 0 1-.91 37.88c6.17-.28 12.64-.35 19.44-.14 6.78.21 13.16.15 19.12-.21zm-2.99 12.84c-1.92-2.39-5.26-4-8.86-4.68a28.58 28.58 0 0 0-10.75-.02c-3.6.65-6.88 1.93-9.85 3.78-2.97 1.87-5.01 4.04-6.11 6.49-1.11 2.46-1.73 4.87-1.91 7.25-.16 2.38 0 4.63.51 6.74.49 2.11 1.29 4 2.38 5.69 1.11 1.68 2.38 2.96 3.81 3.83 2.98 1.85 6.15 2.9 9.51 3.21 3.36.29 6.58-.03 9.68-.98 3.09-.96 5.91-2.41 8.44-4.36 2.54-1.97 4.46-4.34 5.73-7.14 1.26-2.82 1.76-5.91 1.48-9.31-.27-3.4-1.56-7.41-4.06-10.5M1832.48 3118.68l.5-.55c.1-20.73-.04-41.06-.41-60.95-.39-19.9-.8-40.22-1.23-60.94-2.94-.84-5.93-1.48-8.93-1.93-3.02-.45-6.09-.78-9.23-.99-3.12-.23-6.28-.44-9.48-.62-3.17-.2-6.37-.5-9.57-.94-.1 9.46-.28 19.18-.49 29.17-.23 9.97-.39 20.07-.51 30.28-.1 10.2-.16 20.44-.16 30.71s.22 20.36.67 30.28c2.87.61 5.92 1.14 9.16 1.61 3.24.45 6.57.91 9.98 1.38 3.4.45 6.77.94 10.12 1.44 3.33.5 6.52 1.18 9.58 2.05M1879.84 3129.31c.64-7.75.82-16.08.56-24.98-.26-8.9-.3-17.56-.08-25.99 1.8 1.34 3.33 3.19 4.6 5.51 1.28 2.32 2.39 4.83 3.34 7.54.95 2.7 1.79 5.47 2.52 8.32.74 2.85 1.53 5.56 2.37 8.14 11.87 2.37 22.46 3.65 31.81 3.51-1.52-8.91-3.99-17.21-7.43-24.82-3.44-7.61-7.69-14.73-12.78-21.23a48.66 48.66 0 0 0 6.92-6.33c2.11-2.34 3.96-5.03 5.56-8.06 1.59-3.03 2.83-6.53 3.75-10.5.93-3.97 1.49-8.54 1.69-13.7a124.63 124.63 0 0 0-13.64-8.39c-4.82-2.55-9.74-4.94-14.78-7.16-.52 2.71-1.1 5.31-1.73 7.82-.62 2.51-1.44 4.76-2.45 6.77-1 2-2.29 3.64-3.87 4.9-1.59 1.29-3.54 2.01-5.88 2.21-.42-1.97-.69-4.02-.8-6.15-.11-2.13-.18-4.29-.24-6.45-.05-2.17-.16-4.33-.32-6.47-.15-2.15-.45-4.15-.87-6.02-2.88-.81-5.73-1.68-8.56-2.63-2.84-.92-5.65-1.85-8.45-2.76-2.8-.9-5.57-1.68-8.32-2.35-2.76-.66-5.49-1.06-8.2-1.22-.55 19.88-.95 39.77-1.22 59.65-.28 19.88-.64 39.78-1.07 59.69.33.92.99 1.82 1.79 2.14 5.15 2.11 12.3 2.94 17.99 4.11 5.69 1.15 11.63 2.78 17.79 4.9M1890.86 2925.6c-15.13 24.69-49.43 44.52-76.48 23.39-23.13-18.06-11.25-47.51 8.61-62.75 18.29-14.04 39.56-20.32 56.48-37.09 14.7-14.56 29.66-44.97 40.36-61.23 5.13 50.64-12.37 110.59-28.97 137.68",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.59 3173.24v-734.56c0-59.37 85.51-107.51 191-107.51 105.48 0 190.99 48.14 190.99 107.51v734.56h-381.99",
    style: {
      fill: "#d7c3be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.59 2999.09c-105.49 0-191 48.14-191 107.5v-560.42c0-59.36 85.51-107.49 191-107.49 105.48 0 190.99 48.13 190.99 107.49v560.42c0-59.36-85.51-107.5-190.99-107.5",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.21 3230.82c-28.16 61.96-80.45 138.63-80.45 138.63l-183.58-1s-81.43-114.68-97.63-176.68c-.48-1.84-.17-3.28-.27-4.93-1-4.47-1.69-8.98-1.69-13.6 0-59.37 85.51-107.5 191-107.5 105.48 0 190.99 48.13 190.99 107.5 0 9.17-13.38 46.6-18.37 57.58",
    style: {
      fill: "#eeded9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.08 3356.21c0-29.68-42.75-53.75-95.49-53.75-52.75 0-95.51 24.07-95.51 53.75 0 29.69 42.76 53.75 95.51 53.75 52.74 0 95.49-24.06 95.49-53.75",
    style: {
      fill: "#fff6f3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1477.42 3369.45c0-18.92-27.23-34.25-60.83-34.25-33.6 0-60.85 15.33-60.85 34.25 0 18.9 27.25 34.23 60.85 34.23s60.83-15.33 60.83-34.23",
    style: {
      fill: "#d7c3be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500.64 3478.99h-168.11v-70.65c0-9.02 4.73-17.37 12.51-24.54v41.19c0 2.95 2.41 5.36 5.35 5.36 2.94 0 5.35-2.41 5.35-5.36v-49.15c6.09-3.61 13.26-6.56 21.1-8.95v45.27c0 2.94 2.41 5.35 5.35 5.35 2.95 0 5.36-2.41 5.36-5.35v-48.06c7.84-1.64 16.21-2.6 24.96-2.84v47.5c0 2.95 2.41 5.36 5.35 5.36 2.95 0 5.36-2.41 5.36-5.36v-47.36c8.73.39 17.17 1.37 24.96 3.15v47.61c0 2.94 2.41 5.35 5.35 5.35 2.95 0 5.36-2.41 5.36-5.35v-44.49c6.84 2.26 13.11 4.95 18.53 8.17v49.15c0 2.95 2.41 5.36 5.36 5.36 2.94 0 5.36-2.41 5.36-5.36v-41.19c7.77 7.17 12.5 15.52 12.5 24.54v70.65",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.39 3430.35c-2.94 0-5.35-2.41-5.35-5.36v-41.19c3.1-2.86 6.63-5.54 10.7-7.96v49.15c0 2.95-2.41 5.36-5.35 5.36M1482.78 3430.35c-2.95 0-5.36-2.41-5.36-5.36v-49.15c4.08 2.42 7.61 5.1 10.72 7.96v41.19c0 2.95-2.42 5.36-5.36 5.36M1382.19 3417.51c-2.94 0-5.35-2.41-5.35-5.35v-45.27c3.46-1.06 6.98-2.01 10.71-2.79v48.06c0 2.94-2.41 5.35-5.36 5.35M1417.86 3414.12c-2.94 0-5.35-2.41-5.35-5.36v-47.5c1.38-.04 2.68-.23 4.08-.23 2.27 0 4.4.27 6.63.37v47.36c0 2.95-2.41 5.36-5.36 5.36M1453.53 3417.51c-2.94 0-5.35-2.41-5.35-5.35v-47.61c3.75.85 7.24 1.97 10.71 3.12v44.49c0 2.94-2.41 5.35-5.36 5.35",
    style: {
      fill: "#472d32",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500.64 3478.99c0-26.13-37.63-47.31-84.05-47.31-46.43 0-84.07 21.18-84.07 47.31 0 26.12 37.64 47.31 84.07 47.31 46.42 0 84.05-21.19 84.05-47.31",
    style: {
      fill: "#604047",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1473.79 2484.93c-30.96 22.23-41.47 59.1-41.69 96.6-.09 16.65 4.05 32.66-.01 49.15-5.54 22.42-23.35 42.24-47.69 30.17-11.94-5.92-19.67-15.19-24.35-26.15 2.3 30.74 14.59 64.39 7.74 93.04-9.23 38.61-46.83 35.5-71.16 9.66-68.18-72.4-14.61-204.42 70.42-238.22 43.06-17.11 85.14-23.76 106.74-14.25M1302.46 2932.18c2.76-8.9 5.56-17.59 8.44-26.09 2.87-8.49 5.79-17.04 8.8-25.64a51.15 51.15 0 0 1 5.47 8.39c1.62 3.05 3.2 6.19 4.76 9.39 1.57 3.2 3.1 6.42 4.61 9.66 1.52 3.23 3.61 8.51 5.04 9.22 2.57 1.29 12.38-.93 19.25-1.27 6.89-.34 13.47-.94 19.73-1.84.45-18.43.45-37.65 0-57.65-.44-20 2.63-56.38-.67-59.69-.59-.59-5.97.1-9.37.3-3.4.2-6.9.52-10.5.97-3.6.46-7.23 1.07-10.87 1.87-3.66.78-7.14 1.74-10.49 2.84-.11 3.89-.09 7.62.08 11.19.15 3.57.33 7.11.48 10.61.17 3.51.33 7.08.49 10.7.16 3.62.18 7.37.08 11.27a22.37 22.37 0 0 1-5.43-4.59c-1.57-1.82-3.08-3.7-4.53-5.62a62.601 62.601 0 0 0-4.59-5.45c-1.61-1.71-3.55-2.99-5.78-3.83a61.608 61.608 0 0 0-4.25 8.29c-1.23 2.91-2.46 5.85-3.67 8.82-1.22 2.98-2.45 5.9-3.66 8.78-1.22 2.88-2.58 5.7-4.06 8.48-.31-3.44-.42-7.17-.31-11.19.1-4.01.2-8.1.31-12.28.11-4.17.16-8.3.16-12.39s-.21-7.88-.63-11.39c-6.34 1.57-12.71 3.48-19.09 5.76-6.4 2.28-12.96 5.15-19.68 8.65 0 9.35.06 19.01.15 28.96.11 9.95.29 19.89.54 29.81.25 9.93.51 19.77.76 29.55.25 9.76.48 19.17.7 28.2 5.6-1.62 11.69-3.78 18.3-6.4a166.71 166.71 0 0 1 19.43-6.39M1426.86 2869.02c.54-12.46.6-25.25.16-38.37-.45-13.14-1.1-25.78-1.98-37.95-2.87.03-5.78-.02-8.7-.18-2.93-.17-5.88-.26-8.85-.3-3-.01-5.95.04-8.86.19-2.93.15-5.76.54-8.52 1.19-.56 12.51-.85 25.15-.91 37.89-.06 12.75-.36 25.36-.9 37.88 6.16-.28 12.64-.35 19.43-.14 6.79.2 13.16.15 19.13-.21zm-2.99 12.83c-1.92-2.39-5.26-3.99-8.86-4.67a28.58 28.58 0 0 0-10.75-.02c-3.59.66-6.88 1.93-9.85 3.78-2.97 1.86-5.02 4.03-6.11 6.5-1.11 2.45-1.73 4.87-1.91 7.25-.15 2.37 0 4.62.5 6.73.49 2.11 1.29 4 2.39 5.69 1.1 1.69 2.38 2.96 3.8 3.84 2.98 1.84 6.15 2.9 9.52 3.2 3.36.29 6.59-.03 9.67-.98a26.63 26.63 0 0 0 8.45-4.36c2.54-1.96 4.45-4.34 5.73-7.15 1.25-2.81 1.75-5.9 1.48-9.3-.27-3.4-1.57-7.41-4.06-10.51M1478.11 2919.79l.49-.56c.11-20.72-.03-41.04-.4-60.93-.39-19.92-.81-40.23-1.23-60.95-2.95-.83-5.93-1.48-8.94-1.92-3.01-.45-6.09-.79-9.21-1-3.14-.23-6.29-.43-9.48-.62-3.19-.2-6.39-.5-9.59-.94-.1 9.46-.27 19.18-.49 29.16-.23 9.99-.38 20.08-.5 30.29-.1 10.2-.16 20.44-.16 30.71 0 10.26.22 20.36.66 30.28 2.87.61 5.92 1.15 9.17 1.61 3.24.45 6.57.91 9.97 1.37 3.41.46 6.78.95 10.12 1.46 3.34.49 6.53 1.17 9.59 2.04M1525.47 2930.42c.64-7.74.82-16.07.55-24.98-.26-8.9-.29-17.56-.08-25.98 1.81 1.34 3.34 3.18 4.61 5.51 1.27 2.3 2.38 4.82 3.33 7.52.95 2.7 1.8 5.48 2.53 8.34.74 2.84 1.52 5.55 2.37 8.12 11.86 2.38 22.45 3.66 31.81 3.52-1.52-8.91-4-17.22-7.43-24.82-3.44-7.61-7.7-14.72-12.78-21.23 2.48-1.86 4.8-3.97 6.91-6.33 2.11-2.35 3.97-5.03 5.57-8.06 1.58-3.03 2.83-6.53 3.75-10.49.92-3.98 1.48-8.55 1.68-13.71a125.14 125.14 0 0 0-13.63-8.4c-4.82-2.54-9.74-4.92-14.78-7.14-.53 2.69-1.1 5.29-1.74 7.81-.62 2.51-1.44 4.76-2.44 6.77-1.01 2-2.3 3.63-3.88 4.91-1.58 1.27-3.53 2-5.88 2.2-.42-1.97-.68-4.02-.79-6.15-.11-2.13-.19-4.28-.24-6.44-.06-2.18-.16-4.33-.32-6.48-.16-2.15-.45-4.15-.87-6.01-2.88-.81-5.73-1.69-8.56-2.63-2.84-.94-5.65-1.86-8.46-2.77-2.79-.9-5.57-1.68-8.32-2.34-2.76-.66-5.48-1.07-8.2-1.23-.54 19.88-.95 39.76-1.22 59.65-.27 19.88-.63 39.78-1.06 59.68.32.93 1 1.84 1.79 2.16 5.15 2.09 12.3 2.94 17.98 4.1 5.7 1.16 11.64 2.78 17.8 4.9M1536.48 2726.72c-15.12 24.68-49.42 44.51-76.47 23.39-23.13-18.07-11.25-47.51 8.61-62.76 18.28-14.03 39.57-20.32 56.47-37.09 14.71-14.57 29.66-44.97 40.37-61.23 5.13 50.65-12.38 110.6-28.98 137.69",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2682.5 2071.65-607.61 350.81v988.06l607.61-350.8v-988.07",
    style: {
      fill: "#fcbd0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2682.5 3059.72 145.14 89.24v-988.08l-145.14-89.23v988.07",
    style: {
      fill: "#ff9a08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2811.63 3113.77-109.27-67.18v-190.87l109.27 67.19v190.86M2811.63 2522.87l-109.27-67.19v-345l109.27 67.18v345.01M2811.63 2739.69l-109.27-67.18v-25.6l109.27 67.19v25.59M2811.63 2688.91l-109.27-67.19v-25.59l109.27 67.18v25.6M2811.63 2634.31l-109.27-67.19v-25.6l109.27 67.19v25.6",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2220.02 3499.77-145.13-89.25 607.61-350.8 145.14 89.24-607.62 350.81",
    style: {
      fill: "#ffcf48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2574.94 2687.55c-14.24 31.96-35.24 59.81-63.09 71.55-.64 1.45-1.9 2.66-3.94 3.22-40.39 11.08-91.14-2.47-118.34-35.75-24.59-30.09-18.84-84.92-1.92-117.6 4.41-8.53 16.03-19.99 27.39-25.06-22.28-39.55-40.58-81.59-55.84-124.1-16.48-45.9-45.92-107.68-26.87-155.83 28.92 14.95 62.42 21.73 85.14 29.1-5.22-13.46-14.24-70.06-3.36-80.91 23.61 22.49 58.9 36.89 69.2 40.27 11.06-31.67 47.16-72.01 75.48-92.84-1.34 84.87 82.75 338.53 16.15 487.95",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2428.43 2584c-3.03 24.25-19.53 70.03-48.78 68.64-1.45-.07-3.25-.77-3.87-2.22-3.02-6.96-48.03-43.71-64.8-57.85-12.86-10.84-26.37-25.83-29.34-43.04-3.44-19.87 20.17-41.56 37.92-36.67-12.33-17.71-18.55-36.72 6.09-53.28 25.93-17.43 56.58-.33 73.47 21.27 20.21 25.83 33.36 70.59 29.31 103.15",
    style: {
      fill: "#701b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2428.16 2736.37-110.88 43.19 36.32-62.52-68.82-12.51 92.6-67.72s60.34 9.25 50.78 99.56",
    style: {
      fill: "#ff8048",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2615.54 2688.4c-2.73 8.99-9.93 19.94-18.78 23.42 6.91 15.69 4.55 33.82-6.73 47.96-8.11 10.16-23.46 18.08-35.1 14.06.42 7.73-1.8 16.03-5.37 22.22-7.3 12.7-21.22 17.3-35.25 15.17-14.93-2.26-32.22-10.8-41-23.45-5.52-7.95-9.55-21.45-3.24-29.26 58.93-22.81 114.85-70.85 117.54-129.52 24.55 7.81 33.28 41.74 27.93 59.4",
    style: {
      fill: "#701b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2206.78 3276.32c-.1-2.61-.53-5.24-1.27-7.87-.76-2.63-1.72-4.93-2.93-6.92-1.2-1.98-2.57-3.39-4.12-4.22-1.57-.85-3.24-.74-5.03.3-1 .57-1.43 1.69-1.29 3.35.15 1.64.55 3.45 1.2 5.4.66 1.96 1.35 4 2.11 6.1.75 2.1 1.21 3.89 1.42 5.37.4 3.11.14 6.19-.75 9.25-.9 3.06-2.17 5.8-3.83 8.22-1.64 2.42-3.55 4.53-5.71 6.31-2.15 1.77-4.29 3-6.37 3.66-2.61.85-5.15.29-7.67-1.66-2.51-1.97-4.86-5-7.13-9.1-2.25-4.12-4.34-9.05-6.23-14.83-1.9-5.79-3.59-12.05-5.04-18.82-1.44-6.77-2.65-13.85-3.6-21.25-.95-7.39-1.55-14.7-1.79-21.88-.26-7.19-.16-14.17.29-20.89.45-6.74 1.33-12.82 2.62-18.24 1-3.39 2.74-6.02 5.19-7.91 2.45-1.87 5.31-3.06 8.56-3.53 3.25-.47 6.78-.38 10.59.29 3.81.67 7.63 1.81 11.48 3.39 3.86 1.58 7.57 3.57 11.12 5.98 3.55 2.43 6.69 5.09 9.39 8 2.7 2.92 4.88 6 6.52 9.25 1.65 3.25 2.48 6.54 2.48 9.89.21.54.74.13 1.59-1.23.84-1.36 1.38-2.61 1.56-3.8.82-5.81.49-11.32-.96-16.56-1.45-5.23-3.67-9.99-6.69-14.26a49.5 49.5 0 0 0-10.74-11.12c-4.15-3.14-8.48-5.55-12.99-7.21-4.5-1.67-8.95-2.52-13.36-2.51-4.42.02-8.36 1.03-11.86 3.04-5.02 2.9-9.58 6.14-13.75 9.74-4.16 3.61-7.73 8.05-10.73 13.31-3 5.27-5.36 11.58-7.07 18.89-1.7 7.33-2.55 16.13-2.55 26.41 0 7.61.5 16.03 1.5 25.26s2.48 18.39 4.45 27.47c1.93 9.1 4.34 17.72 7.2 25.88 2.85 8.16 6.13 15.02 9.83 20.56 3.69 5.53 7.86 9.34 12.46 11.43 4.61 2.07 9.57 1.57 14.86-1.49 3.52-2.02 6.9-4.5 10.14-7.45 3.25-2.94 6.13-6.51 8.65-10.7 2.48-4.17 4.49-9 6-14.48 1.5-5.47 2.25-11.74 2.25-18.82M2261.15 3163.44c.71-.4 1.36.04 1.95 1.37.6 1.33 1.12 3.22 1.58 5.7.45 2.47.79 5.31 1.06 8.5.24 3.2.36 6.4.36 9.61 0 3.07-.41 6.27-1.26 9.63-.86 3.36-2.02 6.54-3.46 9.52-1.45 2.96-3.12 5.63-5.04 8-1.89 2.36-3.85 4.13-5.86 5.29-1.79 1.04-3.34 1.24-4.65.58-1.29-.66-2.4-1.76-3.3-3.3-.91-1.54-1.55-3.4-1.96-5.57-.39-2.17-.58-4.34-.58-6.47 0-9.21 1.92-17.73 5.77-25.56 3.84-7.83 8.98-13.6 15.39-17.3zm-2.1-9.19a42.92 42.92 0 0 0-9 7.39c-2.7 2.89-4.62 4.67-5.72 5.31-1.09.36-2.12-.58-3.09-2.83-.94-2.26-1.7-5.01-2.32-8.28-.59-3.25-.88-6.63-.81-10.13.03-3.49.52-6.23 1.43-8.24 1.09-2.89 2.63-4.59 4.64-5.08 1.41.13 2.94.84 4.58 2.17 1.65 1.31 3.22 3 4.74 5.07 1.5 2.06 2.77 4.38 3.82 6.89 1.05 2.53 1.64 5.1 1.73 7.73zm27.93 9.1c-2.3-3.88-5.06-6.54-8.27-7.95-3.2-1.42-6.54-2.32-10.06-2.7-.5-.51-1.14-1.81-1.95-3.87-.79-2.09-1.77-4.46-2.93-7.14-1.13-2.67-2.49-5.38-4.03-8.16-1.57-2.78-3.36-5.11-5.43-6.98-2.03-1.9-4.4-3.08-7.05-3.55-2.66-.47-5.57.22-8.8 2.08-2.1 1.2-4.16 3.01-6.21 5.39-2.06 2.39-3.86 5.21-5.42 8.43-1.53 3.23-2.79 6.75-3.76 10.58-.94 3.82-1.43 7.8-1.43 11.93 0 1.08.14 3.19.4 6.39.24 3.2.71 6.42 1.41 9.7.71 3.26 1.68 6.01 2.93 8.22 1.27 2.21 2.88 2.94 4.88 2.19l1.59-.52.29.53-.51 1.8c-.3.84-.61 1.95-.92 3.32-.5 2.16-1.17 5-2.02 8.49-.84 3.49-1.27 7.91-1.27 13.25 0 1.47.46 3.66 1.43 6.58.93 2.93 2.33 5.62 4.12 8.14 1.81 2.48 4.03 4.35 6.69 5.55 2.65 1.2 5.69.81 9.08-1.15 3.71-2.14 7-5.18 9.91-9.13 2.9-3.94 5.33-8.28 7.28-13 1.94-4.74 3.43-9.66 4.42-14.77 1.01-5.13 1.45-9.85 1.37-14.21-.1-4.48-.4-8.3-.91-11.48-.49-3.19-.85-5.4-1.04-6.61-.22-.95 0-1.68.58-2.14.92-.4 1.99-.49 3.23-.27 1.26.21 2.54.58 3.84 1.09 1.3.51 2.48 1.1 3.52 1.78 1.06.65 1.85 1.24 2.33 1.76l1.58-.32c.75-.84 1.13-1.92 1.13-3.25",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2286.99 3187.97.52-1.6 1.21-2.2 1.43-1.42 1.34.63c.6 1.11 1 2.25 1.2 3.4.2 1.15.45 2.58.75 4.27.7 4.27.62 7.08-.22 8.44-.85 1.37-1.68 1.19-2.49-.47-.69-1.47-1.33-2.94-1.88-4.42-.55-1.48-1.15-3.7-1.86-6.63zm15.76 18.53c.3-.84.18-2.65-.37-5.38-.55-2.76-1.29-5.78-2.19-9.07-.89-3.28-1.87-6.45-2.91-9.51-1.07-3.07-2-5.3-2.77-6.72l-.09-.56.23-.52c1.08-2.37 2.37-4.51 3.82-6.41 1.45-1.92 2.85-3.85 4.2-5.84a56.21 56.21 0 0 0 3.76-6.37c1.14-2.27 2.02-4.91 2.63-7.92.6-3.02.6-6.62 0-10.81-.61-4.2-1.42-8.69-2.48-13.49-1.04-4.8-2.2-9.61-3.45-14.43-1.26-4.81-2.28-9.26-3.07-13.34-.81-4.07-1.21-7.54-1.21-10.42 0-2.86.69-4.71 2.1-5.51 1-.58 2.36.11 4.05 2.07 1.71 1.94 3.55 4.68 5.55 8.2 2.01 3.51 4.09 7.55 6.25 12.12 2.15 4.55 4.11 9.19 5.92 13.89 1.81 4.69 3.38 9.19 4.74 13.48 1.35 4.3 2.26 7.91 2.78 10.81l.9.39 1.87-1.08c.66-.59 1.22-1.34 1.66-2.26.45-.94.52-1.92.22-2.93-.6-2.61-1.61-6.22-3-10.89-1.39-4.66-3.07-9.68-4.96-15.05a316.59 316.59 0 0 0-6.24-16.22c-2.24-5.45-4.52-10.25-6.83-14.38-2.3-4.15-4.6-7.29-6.89-9.44-2.33-2.12-4.43-2.65-6.33-1.56-1.39.81-2.96 2.02-4.72 3.64-1.76 1.6-3.38 3.48-4.88 5.62s-2.78 4.57-3.83 7.3c-1.06 2.76-1.58 5.73-1.58 8.94 0 4.67.52 9.54 1.51 14.64 1 5.09 2.13 9.89 3.37 14.37 1.25 4.48 2.48 8.41 3.69 11.78 1.21 3.39 1.94 5.8 2.24 7.23.51 1.57.66 3.22.46 4.93-.21 1.72-1.1 3.52-2.7 5.37-.4.63-1.69 2.37-3.83 5.21-2.16 2.84-4.45 6.21-6.84 10.06-2.4 3.85-4.59 7.82-6.52 11.88-1.96 4.05-2.93 7.62-2.93 10.69.08 2.22.71 5.36 1.86 9.44a70.45 70.45 0 0 0 4.58 11.87c1.92 3.83 4.07 7.07 6.54 9.64 2.45 2.6 4.98 3.47 7.59 2.63.99-.58 1.97-1.5 2.92-2.79.96-1.29 1.81-2.67 2.55-4.17.74-1.5 1.35-3.06 1.81-4.65.45-1.59.71-3.09.82-4.48",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2400.51 3100.8c.71 1.33 1.33 1.91 1.89 1.72.54-.19.96-.75 1.18-1.69.26-.95.35-2.1.23-3.43-.09-1.35-.38-2.48-.88-3.4-.71-.79-1.71-2.62-3.02-5.47-1.29-2.86-2.82-6.11-4.56-9.77-1.76-3.67-3.68-7.44-5.71-11.32-2.07-3.89-4.1-7.38-6.17-10.46-2.05-3.09-4.06-5.44-6-7.05-1.97-1.61-3.69-1.97-5.19-1.11-1.6.93-3.24 2.52-4.95 4.76-1.7 2.26-3.22 4.67-4.58 7.26a56.207 56.207 0 0 0-3.38 7.75c-.91 2.59-1.35 4.69-1.35 6.3-.31 4.03-.18 8.26.36 12.68.56 4.43 1.33 8.78 2.33 13.08 1.01 4.29 2.16 8.46 3.47 12.52 1.31 4.04 2.53 7.76 3.67 11.09 1.15 3.34 2.1 6.3 2.86 8.87.76 2.57 1.13 4.52 1.13 5.85l-.77 2.24-1.19 1.29c-1 .58-2.53-.27-4.58-2.56-2.05-2.28-4.32-5.4-6.84-9.37-2.49-3.97-5.02-8.53-7.57-13.74-2.57-5.21-4.8-10.45-6.69-15.78-1.89-5.29-3.31-10.36-4.2-15.18-.91-4.83-.95-8.86-.14-12.12-.31-.91-1.26-.88-2.87.04-1.59.93-3.32 2.45-5.16 4.59-1.87 2.13-3.55 4.72-5.04 7.72-1.52 2.99-2.26 6.1-2.26 9.3 0 3.07.12 6.84.38 11.29.25 4.47.59 9.21 1.04 14.23.46 4.99.96 10.08 1.51 15.24.56 5.16 1.12 9.93 1.73 14.32.6 4.39 1.19 8.19 1.79 11.37.62 3.2 1.21 5.35 1.81 6.47.9-.52 2.07-1.47 3.54-2.83 1.44-1.38 2.89-2.91 4.34-4.62 1.45-1.7 2.69-3.42 3.68-5.14 1-1.7 1.51-3.22 1.51-4.56 0-1.86-.33-4.34-.98-7.45-.66-3.09-1.4-6.39-2.25-9.91a214.5 214.5 0 0 1-2.26-10.41c-.65-3.42-.96-6.41-.96-8.95 0-.94.19-1.91.59-2.95l.6-1.15c.4 2.04 1.36 4.79 2.84 8.27 1.52 3.46 3.33 7.13 5.43 10.99 2.09 3.86 4.4 7.74 6.9 11.63 2.5 3.89 4.94 7.33 7.36 10.27 2.4 2.95 4.65 5.19 6.75 6.71 2.11 1.52 3.81 1.91 5.11 1.15 1.1-.63 2.34-1.75 3.75-3.36 1.4-1.61 2.69-3.46 3.9-5.56 1.21-2.09 2.23-4.28 3.08-6.58.85-2.3 1.28-4.44 1.28-6.45-.1-5.82-.98-11.78-2.62-17.9-1.65-6.12-3.41-12.33-5.26-18.6-1.86-6.26-3.46-12.58-4.8-18.94-1.37-6.36-1.78-12.57-1.28-18.59l.74-1.23.91-.52c2.61 1.31 5.05 3.59 7.37 6.86 2.28 3.28 4.5 6.91 6.6 10.91 2.1 3.99 4.11 7.92 6.08 11.8 1.95 3.88 3.88 7.07 5.77 9.58",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2333.55 2978.81.15-1.05c0-1.36-1.01-.97-3.34.37-2.75 1.58-23.46 14.13-28.53 17.06-4.21 2.42-17.82 9.12-23.61 12.47-1.16.67-2.02 1.36-2.46 1.61-.89.7-2.03 1.36-3.34 2.12-3.61 2.09-8.54 4.54-11.01 5.98-3.17 1.82-2.46 2.77-2.46 6.44 0 3.09.87 29.67.87 34.11 0 3.87-.72 17.43-.72 23.82 0 1.35 0 2.32.14 2.81.29 2.35 1.02 17.02 1.46 26.43l-8.11 4.88c-5.07 3.11-8.41 5.05-9.86 6.08-1.3.94-2.32 1.53-3.04 1.94l-15.36 8.87c-2.17 1.26-4.34 2.31-6.06 3.12l-3.06 1.37c-.15-1.08-.15-2.23-.15-3.38v-6.39c0-2.13-.14-3.79-.27-5.25l-.32-2.35 3.21-1.84c1.88-1.09 4.03-2.14 5.8-3.15l10.4-6.02c5.81-3.35 10.15-5.09 13.48-7.01 2.62-1.51 2.9-2.83 2.9-3.99 0-1.92-.14-3.01-.73-5.19-.13-2.05-.85-1.61-2.01-.96-1.31.76-3.62 2.29-5.81 3.55-2.02 1.17-10.73 6.56-13.47 8.15l-7.66 4.43c-1.76 1.02-3.64 2.11-5.66 3.08v-18.76c0-9.86-.29-19.56-.45-22.38-.11-2.43-.27-6.01-.27-9.68 0-5.04.16-9.76.16-11.5 0-3.1-1.45-2.07-3.35-.97l-10 5.76c-2.31 1.53-1.74 3.72-1.88 7.85-.14 1.64-.29 5.2-.29 9.27 0 5.41.15 11.9.15 16.15 0 7.55.57 28.09.57 32.35 0 4.05-.57 9.03-.57 17.35 0 7.93.43 11.35.43 16.77v17.41c0 3.67.58 9.9.58 13.58v.77c0 2.9.87 2.6 2.03 1.92 1.15-.66 3.32-2.3 4.93-3.22 5.2-3.01 14.05-7.34 17.96-9.6l15.77-9.3c2.04-1.17 6.1-3.51 12.33-7.31l8.54-5.14 2.47-1.41.71-.41 1.01-.59 3.76-2.37 1.33-.76c.57-.34.86-.68.86-2.04 0 .58-1.02-33.06-1.02-38.47l-.15-27.57c0-3.1.31-12.36.31-18.16 0-2.32 0-4.06-.16-4.94-.15-1.66 0-2.71 0-3.48l.16-1.06 3.47-2.39c2.17-1.44 4.93-3.24 7.68-4.63 5.21-3 21.43-11.99 26.79-15.08 5.52-3.18 19.84-12.22 22.03-13.48 1.29-.95 1.58-1.51 1.58-2.09l-.29-1.95v-8.89c0-4.26 1.45-21.54 1.45-23.66M2382.62 3016.99c0 .39-.14.85-.43 1.81-1.02 2.89-5.49 19.41-6.95 25.86-1.87 7.08-3.04 12.78-3.47 14-1.02 3.48-1.18 4.73-1.89 5.14-.58.34-1.01-3.09-1.75-6.34-.71-2.67-3.02-11.59-3.76-14.84-.71-3.65-2.47-8.45-3.17-10.93-.31-1.18-.43-2.07-.43-2.85 0-.77.27-1.32 1.29-1.91 1.73-1 14.77-8.13 17.24-8.98 2.02-.78 3.32-1.93 3.32-.96zm-14.77 78.73c.59 1.6 1.29 1.58 2.03.18 1.02-1.56 1.3-3.84 1.89-6.5.43-2.94 5.63-20.66 7.66-27.64 2.2-7.25 4.21-15.39 6.24-24.28 1.88-8.64 9.26-32.81 12.31-43.85 3.04-10.65 10.43-33.68 12.47-40.08 1.87-6.11 4.77-17.06 6.8-21.33.43-1.4.71-2.34.71-2.92 0-1.36-1.3-.8-2.58-.05l-10.45 6.02c-1.15.67-1.88 4.57-2.9 8.06-1.15 3.57-4.93 19.67-5.63 23.17-.74 3.32-2.62 9.44-3.64 13.11-.73 3.72-1.45 4.71-2.6 5.39-1.02.58-3.33 1.53-5.8 2.76-2.3.75-11.44 6.41-15.49 8.17-1.3.56-3.05 1.57-4.64 2.49-3.46 2-6.95 4.2-7.69 4.62-1.29.75-1.44-1.3-1.87-3.17-.28-1.77-2.61-12.6-3.04-16.03l-1.59-7.4-1.17-4.94c-.57-2.56-.86-3.18-1.87-2.59l-8.56 4.95-.72 1.18c0 .58.29 1.39.58 2.37.58 1.41.87 1.63 2.03 6.18 1.16 4.56 5.22 20.19 6.37 27.65 1.15 8.04 3.78 16.77 5.36 21.86 1.16 5.71 1.9 8.38 3.78 16.38 1.87 8.01 3.91 16.11 5.5 22.16l3.62 13.38c1.17 5.32 2.31 8.91 2.89 10.7M2450.19 2912.05c0-3.3-1.6-1.8-2.76-1.13-1.31.76-5.49 3.76-7.67 5.02-2.03 1.17-9.7 5.02-11.15 5.86-1.6.91-1.45 2.19-1.45 5.27l-.15 47.48v18.17c0 11.03 0 23.02-.28 27.44-.15 2.4-.15 4.91-.15 7.43 0 5.22.15 10.17.15 12.68l.15 15.19c0 1.34.56 1.41 1.44.9 1.02-.59 2.32-1.92 3.19-2.42l16.51-9.72c2.17-1.26 2.31-2.69 2.31-4.05 0-1.35.16-3.95.16-9.56 0-5.41-1.61-19.57-1.61-25.76v-12.77c0-2.5 0-5.22.16-8.21 1.29 1.19 2.45 2.45 3.47 3.81l5.36 6.18c2.75 3.05 14.2 17.71 15.65 19.78 1.45 2.07 7.38 7.33 8.25 10.12.73 2.67 2.9.85 4.19.29 1.31-.75 3.91-1.88 6.08-2.94l.59-.33c1.74-1 2.61-2.08 2.61-2.86 0-.96-.73-1.32-1.46-1.87-.72-.54-11.28-11.66-14.04-14.71-2.31-3.29-14.78-18.72-16.79-20.66-1.88-2.01-7.4-11.01-7.4-11.98 0-1.35 1.61-3.63 3.76-7.98 1.88-4.17 9.43-18.97 10.99-22.01 1.61-3.05 10.16-21.33 15.23-30.44 4.93-8.84 12.17-23.65 13.33-25.87l.29-.94c0-1.15-1.59-.82-2.9.31-1.58.92-9.27 4.78-12.01 6.36-2.9 1.49-4.5 3.38-5.66 5.39-1.01 1.94-3.18 5.72-5.35 10.25-2.18 4.35-6.09 12.02-10.01 19.5-1.87 3.61-5.35 9.29-8.25 14.63l-5.5 9.38v-16.26c0-4.05.72-15.5.72-18.97M2519.78 2929.88c0-4.45.57-6.72.57-11.16l.15-23.1c0-3.29-.15-6.68-.15-9.59-.12-1.65-.12-3.2-.12-4.75 1.88-1.28 3.75-2.37 5.49-3.37 3.04-1.94 6.66-4.04 9.42-5.63 5.36-3.09 10.13-6.23 15.36-9.25 5.2-3.01 10.13-5.28 14.05-7.53 3.91-2.26 7.67-4.82 9.27-5.74 1.58-.93 1.58-1.88 1.58-4.02 0-1.74-.29-3.7-.29-5.81 0-1.75-.86-1.83-3.03-.58-.73.42-1.59.92-2.61 1.7-2.61 1.89-9.13 5.85-15.8 9.7-3.6 2.09-7.24 4.18-10.42 5.82-2.46 1.23-5.22 2.82-8.11 4.5-7.67 4.42-15.93 9.58-18.98 11.34-2.89 1.67-3.32 3.08-3.32 4.81 0 .98.15 1.86.15 3.02l.12 1.66c0 1.35-.27 2.68-.27 11.18 0 11.8-.75 27.31-.75 40.27 0 12.95 1.18 31.42 1.18 39.35 0 7.75 0 22.44-.43 29.84-.44 7.41 6.94-.15 11.42-2.73 4.5-2.6 16.53-8.39 24.36-12.9 7.51-4.35 22.15-13.37 25.2-15.13 3.03-1.76 2.46-4.52 2.46-6.64v-2.12c0-1.94 0-4.46-.58-4.13-1.61.94-1.88 1.68-4.64 3.26l-23.19 13.39-17.94 10.56c-2.19 1.25-4.65 2.29-6.53 3.19l-3.33 1.53-.29-5.05c-.14-2.82-.14-6.11-.14-9.01 0-5.42.59-10.78.59-15.23v-7.74c0-1.54 0-3.08.12-4.91 1.33-.95 2.62-1.7 3.91-2.44l5.81-3.36c2.47-1.42 5.5-2.39 10-4.99 4.64-2.68 9.57-6.3 11.29-7.3 1.74-1 4.07-1.77 7.53-3.77 2.6-1.5 7.1-4.68 10-6.35l2.17-1.06.88-.31c1.59-.92 1.88-2.83 1.72-3.52-.13-.89-.13-5.33-.27-6.78-.16-1.66 0-2.14-2.19-.88-2.04 1.17-14.48 10.49-20 13.66-5.34 3.1-12.3 7.13-18.1 9.88-2.89 1.09-6.06 3.12-8.53 4.55-1.45.83-2.76 1.59-4.07 2.53l-.43-2.84c-.15-1.65-.29-3.9-.29-6.02M2620.79 2936.35c-14.05 8.1-20.27 1.83-20.27-9.77 0-11.8 8.26-23.71 15.5-33.12 7.39-8.91 31-28.73 31-61.6 0-33.26-23.47-24.36-36.07-17.09-12.46 7.21-22.45 24.76-23.62 26.99-1.15 2.02-1.15 3.18-.7 3.88.43.73 2.02 4.65 3.17 3.98l.29-.17c.88-.5.73-.62 2.9-4.76 2.32-4.44 11.29-15.42 16.51-18.43 5.22-3.02 21.58-11.69 21.58 10.35 0 11.02-11.44 23.43-22.6 38.57-11.01 14.68-21.58 31.23-21.58 52.5 0 25.53 18.98 28.1 33.46 19.74 14.21-8.19 23.62-25.81 25.06-27.99 1.02-1.57 1.45-2.6 1.45-3.56l-.58-1.21c-.71-.55-2.59-4.3-3.77-3.63-.57.35-1.16 1.07-1.87 2.06l-1.02 1.75c-1.6 2.46-10.72 16.82-18.84 21.51",
    style: {
      fill: "#701b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2354.55 2893.32c-23.03 16.22-46.55 8.3-59.83.87-14.65-8.2-29.56-19.36-31.84-37.27-1.61-12.81 4.12-24.87 16.02-30.42 24.7-11.49 69.48 5.18 80.52 29.95 5.22 11.7 5.85 29.31-4.87 36.87M2230.66 2649.53c-23.04 16.23-46.56 8.3-59.83.87-14.66-8.2-29.58-19.36-31.84-37.27-1.62-12.81 4.1-24.87 16.01-30.42 24.7-11.49 69.48 5.18 80.52 29.95 5.22 11.7 5.85 29.31-4.86 36.87M2199.37 2808.89c-2.74 25.33-31 50.45-48.83 17.03-12.93-24.22-11.7-48.8-10.31-60.51 3.14-26.35 39.58-62.47 66.6-42.54 26.27 19.37-4.55 58.98-7.46 86.02M2261.05 2450.36c-1.99 18.45-22.59 36.75-35.58 12.41-9.41-17.65-8.52-35.56-7.51-44.08 2.29-19.2 28.84-45.52 48.53-31 19.13 14.11-3.32 42.96-5.44 62.67",
    style: {
      fill: "#ff9a08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2221.97 2696.25c1.99 18.45 22.58 36.74 35.57 12.4 9.42-17.65 8.52-35.55 7.51-44.08-2.29-19.2-28.83-45.51-48.52-30.99-19.14 14.1 3.32 42.96 5.44 62.67M2234.64 2536.88c-30.49 28.12-88.06-7.93-97.46-20.4-25.97-34.47 11.5-53.51 43.41-46.23 19.01 4.32 40.37 13.32 51.95 29.71 7.56 10.7 13.03 26.84 2.1 36.92M2186.47 2936.12c-12.68-39.49 44.23-76.56 59.5-79.84 42.2-9.07 43.7 32.94 23.69 58.83-11.92 15.42-29.07 31.01-48.81 34.63-12.88 2.36-29.83.54-34.38-13.62",
    style: {
      fill: "#ff9a08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2641.07 2784.96c-79.7 53.64-171.41 94.69-257.95 136.11-81.27 38.91-166.75 83.77-254 107.43l-.43-1.01c81.47-45.95 172.09-78.66 256.36-119.59 84.87-41.21 166.18-90.91 251.71-130.32 4.97-2.29 8.93 4.27 4.31 7.38M2668.09 2975.34c-28.16 25.34-66.47 39.16-101.2 53.59-44.58 18.52-89.4 34.72-136.5 45.64-1.15.27-1.53-1.31-.48-1.73 44.37-17.52 89.35-34.14 132.49-54.57 33.83-16.04 66.26-38.4 102.28-48.8 3.27-.95 6.06 3.49 3.41 5.87",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2647.88 2295.76c-.82 2.62-4.12 2.34-5.05 0-4.51-11.44-5.31-24.57-9.03-36.44-3.78-12.06-11.18-22.85-14.15-34.98-1.33-5.4 5.38-9.6 9.44-5.51 15.76 15.9 25.55 55.47 18.79 76.93M2630.63 2173.73c-4.29 7.33-14.29 10.15-20.12 16.44-7.67 8.26-12.4 18.64-16.22 29.1-2.48 6.81-13.12 4.14-11.03-3.05 3.76-12.97 7.73-26.22 16.5-36.8 6.45-7.79 18.57-18.2 29.1-12.47 2.35 1.27 3.1 4.53 1.77 6.78",
    style: {
      fill: "#ff9a08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1718.2 2411.4-16.6-155.12c0-25.5-38.88-46.18-86.83-46.18-47.94 0-86.82 20.68-86.82 46.18l-16.6 161.63 206.85-6.51M2054.63 2218.47l-16.59-155.11c0-25.51-38.87-46.19-86.82-46.19-47.95 0-86.82 20.68-86.82 46.19l-16.6 161.63 206.83-6.52",
    style: {
      fill: "#c6aaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1886.41 2314.94-16.6-155.12c0-25.51-38.87-46.19-86.82-46.19-47.94 0-86.81 20.68-86.81 46.19l-16.61 161.63 206.84-6.51M2222.86 2119.5l-16.6-155.12c0-25.51-38.87-46.19-86.83-46.19-47.94 0-86.81 20.68-86.81 46.19l-16.6 161.63 206.84-6.51M2582.23 2130.96l-16.6-155.13c0-25.5-38.87-46.17-86.82-46.17-47.95 0-86.82 20.67-86.82 46.17l-16.6 161.64 206.84-6.51",
    style: {
      fill: "#c6aaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2396.5 2022.13 2379.9 1867c0-25.5-38.87-46.18-86.82-46.18-47.95 0-86.82 20.68-86.82 46.18l-16.6 161.64 206.84-6.51",
    style: {
      fill: "#c6aaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1478.26 2353.88-.02 2.3v26.47s3.63.14 8.32.27c7.14 11.26 18.78 22.04 34.86 31.33l187.63 108.87c52.29 30.19 132.12 33.5 177.4 7.35l695.35-401.46c7.95-4.59 14.24-9.82 19.07-15.45h11.48v-33.5l-.3-.11c-2.05-18.77-16.54-38.1-42.98-53.37l-187.63-108.86c-52.29-30.19-132.12-33.5-177.4-7.36l-695.36 401.46c-19.51 11.27-29.5 26.25-30.42 42.06",
    style: {
      fill: "#d7c3be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1508.68 2337.61 695.36-401.46c45.28-26.15 125.11-22.84 177.4 7.35l187.63 108.86c52.29 30.19 58.02 76.29 12.73 102.43l-695.35 401.46c-45.28 26.15-125.11 22.84-177.4-7.35l-187.63-108.86c-52.29-30.2-58.02-76.29-12.74-102.43",
    style: {
      fill: "#eeded9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.51 2544.29c57.11 0 103.42-24.64 103.42-55.01 0-30.38-46.31-55.01-103.42-55.01-57.12 0-103.42 24.63-103.42 55.01 0 30.37 46.3 55.01 103.42 55.01M1614.77 2437.67c57.12 0 103.43-24.64 103.43-55.02 0-30.38-46.31-55.01-103.43-55.01-57.11 0-103.42 24.63-103.42 55.01s46.31 55.02 103.42 55.02M1968.73 2449.02c57.11 0 103.41-24.63 103.41-55.01s-46.3-55.02-103.41-55.02c-57.12 0-103.42 24.64-103.42 55.02 0 30.38 46.3 55.01 103.42 55.01M1782.99 2342.39c57.13 0 103.42-24.62 103.42-55.01 0-30.38-46.29-55.01-103.42-55.01-57.11 0-103.42 24.63-103.42 55.01 0 30.39 46.31 55.01 103.42 55.01M2136.94 2358.38c57.12 0 103.43-24.63 103.43-55.01s-46.31-55.01-103.43-55.01c-57.11 0-103.41 24.63-103.41 55.01s46.3 55.01 103.41 55.01M1951.22 2251.75c57.11 0 103.42-24.63 103.42-55.01s-46.31-55.01-103.42-55.01c-57.12 0-103.42 24.63-103.42 55.01s46.3 55.01 103.42 55.01M2305.17 2263.11c57.12 0 103.42-24.63 103.42-55.01s-46.3-55.01-103.42-55.01c-57.12 0-103.42 24.63-103.42 55.01s46.3 55.01 103.42 55.01M2119.43 2156.48c57.12 0 103.43-24.62 103.43-55.01 0-30.38-46.31-55.01-103.43-55.01-57.11 0-103.41 24.63-103.41 55.01 0 30.39 46.3 55.01 103.41 55.01M2478.81 2168.58c57.11 0 103.42-24.63 103.42-55.02 0-30.37-46.31-55.01-103.42-55.01s-103.42 24.64-103.42 55.01c0 30.39 46.31 55.02 103.42 55.02",
    style: {
      fill: "#ceb5b3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2293.08 2061.95c57.11 0 103.42-24.63 103.42-55.01s-46.31-55.01-103.42-55.01c-57.12 0-103.42 24.63-103.42 55.01s46.3 55.01 103.42 55.01",
    style: {
      fill: "#dbc2c1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1599.63 2372.05c-38.38 18.44-55.71 70.03-40.5 115.88 15.77 14.49 34.93 23.06 55.63 23.06 43.75 0 80.74-37.95 92.98-90.17-.54-8.39-2.1-16.45-5.27-23.83-13.85-32.11-57.89-46.54-102.84-24.94",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1614.76 2328.08c-48.44 0-82.57 15.73-96.05 34.63-.8 6.64-1.23 13.45-1.23 20.39 0 43.41 16.49 81.7 41.65 104.83-15.21-45.85 2.12-97.44 40.5-115.88 44.95-21.6 88.99-7.17 102.84 24.94 3.17 7.38 4.73 15.44 5.27 23.83 2.8-11.93 4.32-24.59 4.32-37.72 0-6.94-.42-13.75-1.23-20.39-13.74-18.06-47.61-34.63-96.07-34.63",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.79 2489.74c4.93 7.59 22.57 7.16 33.95-4.72 15.25-15.9 17.32-49.8-16.76-33.65-13.04 6.18-25.91 24.96-17.19 38.37",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.36 2478.67c-38.38 18.44-55.71 70.04-40.5 115.88 15.78 14.5 34.94 23.07 55.64 23.07 43.74 0 80.73-37.96 92.98-90.17-.55-8.4-2.1-16.46-5.28-23.83-13.84-32.11-57.88-46.54-102.84-24.95",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.5 2434.71c-48.45 0-82.58 15.72-96.06 34.63-.8 6.63-1.23 13.44-1.23 20.38 0 43.42 16.5 81.71 41.65 104.83-15.21-45.84 2.12-97.44 40.5-115.88 44.96-21.59 89-7.16 102.84 24.95 3.18 7.37 4.73 15.43 5.28 23.83 2.8-11.93 4.31-24.59 4.31-37.73 0-6.94-.42-13.75-1.23-20.38-13.75-18.07-47.6-34.63-96.06-34.63",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810.53 2596.37c4.93 7.59 22.56 7.15 33.95-4.72 15.24-15.9 17.31-49.81-16.77-33.65-13.03 6.18-25.9 24.96-17.18 38.37",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.12 2276.33c-38.38 18.45-55.72 70.04-40.5 115.89 15.77 14.49 34.93 23.06 55.64 23.06 43.74 0 80.73-37.95 92.97-90.17-.54-8.4-2.1-16.45-5.27-23.83-13.84-32.11-57.88-46.54-102.84-24.95",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.26 2232.37c-48.46 0-82.58 15.73-96.06 34.63-.81 6.64-1.23 13.44-1.23 20.38 0 43.42 16.5 81.71 41.65 104.84-15.22-45.85 2.12-97.44 40.5-115.89 44.96-21.59 89-7.16 102.84 24.95 3.17 7.38 4.73 15.43 5.27 23.83 2.8-11.93 4.32-24.6 4.32-37.73 0-6.94-.43-13.74-1.23-20.39-13.75-18.06-47.61-34.62-96.06-34.62",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.28 2394.03c4.94 7.59 22.57 7.16 33.95-4.72 15.24-15.9 17.31-49.81-16.77-33.65-13.03 6.17-25.9 24.95-17.18 38.37",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.85 2382.96c-38.38 18.44-55.71 70.03-40.5 115.88 15.78 14.5 34.93 23.07 55.64 23.07 43.74 0 80.73-37.96 92.98-90.18-.55-8.39-2.11-16.45-5.28-23.82-13.85-32.12-57.88-46.55-102.84-24.95",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1968.99 2338.99c-48.45 0-82.58 15.73-96.06 34.63-.8 6.64-1.23 13.45-1.23 20.39 0 43.42 16.49 81.71 41.65 104.83-15.21-45.85 2.12-97.44 40.5-115.88 44.96-21.6 88.99-7.17 102.84 24.95 3.17 7.37 4.73 15.43 5.28 23.82 2.79-11.92 4.31-24.59 4.31-37.72 0-6.94-.42-13.75-1.23-20.4-13.74-18.05-47.61-34.62-96.06-34.62",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.01 2500.66c4.94 7.58 22.57 7.15 33.96-4.73 15.24-15.9 17.31-49.8-16.77-33.65-13.04 6.18-25.91 24.97-17.19 38.38",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935.46 2185.74c-38.38 18.43-55.71 70.03-40.5 115.87 15.78 14.51 34.94 23.08 55.64 23.08 43.74 0 80.73-37.96 92.98-90.18-.55-8.4-2.1-16.45-5.29-23.83-13.83-32.11-57.87-46.54-102.83-24.94",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1950.6 2141.77c-48.45 0-82.58 15.73-96.06 34.63-.81 6.64-1.23 13.45-1.23 20.39 0 43.41 16.5 81.71 41.65 104.82-15.21-45.84 2.12-97.44 40.5-115.87 44.96-21.6 89-7.17 102.83 24.94 3.19 7.38 4.74 15.43 5.29 23.83 2.79-11.93 4.3-24.59 4.3-37.72 0-6.94-.41-13.75-1.22-20.39-13.75-18.06-47.61-34.63-96.06-34.63",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1960.63 2303.43c4.93 7.59 22.56 7.16 33.94-4.72 15.25-15.9 17.32-49.8-16.76-33.65-13.04 6.18-25.9 24.96-17.18 38.37",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2121.2 2292.37c-38.39 18.44-55.72 70.03-40.51 115.87 15.78 14.5 34.93 23.07 55.64 23.07 43.74 0 80.73-37.95 92.97-90.17-.54-8.4-2.09-16.45-5.27-23.82-13.84-32.13-57.88-46.55-102.83-24.95",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2136.33 2248.4c-48.45 0-82.57 15.73-96.06 34.63-.8 6.64-1.22 13.45-1.22 20.38 0 43.41 16.49 81.72 41.64 104.83-15.21-45.84 2.12-97.43 40.51-115.87 44.95-21.6 88.99-7.18 102.83 24.95 3.18 7.37 4.73 15.42 5.27 23.82 2.8-11.93 4.32-24.6 4.32-37.73 0-6.93-.42-13.74-1.23-20.39-13.74-18.06-47.6-34.62-96.06-34.62",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2146.35 2410.06c4.94 7.59 22.57 7.15 33.96-4.72 15.24-15.9 17.31-49.81-16.77-33.66-13.04 6.18-25.91 24.97-17.19 38.38",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2104.95 2089.71c-38.4 18.44-55.73 70.03-40.52 115.88 15.78 14.49 34.94 23.06 55.65 23.06 43.73 0 80.73-37.95 92.97-90.17-.55-8.39-2.1-16.45-5.28-23.82-13.83-32.12-57.88-46.55-102.82-24.95",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2120.08 2045.74c-48.46 0-82.59 15.73-96.06 34.63-.81 6.64-1.23 13.44-1.23 20.39 0 43.41 16.49 81.7 41.64 104.83-15.21-45.85 2.12-97.44 40.52-115.88 44.94-21.6 88.99-7.17 102.82 24.95 3.18 7.37 4.73 15.43 5.28 23.82 2.8-11.93 4.31-24.59 4.31-37.72 0-6.95-.42-13.75-1.23-20.39-13.74-18.06-47.6-34.63-96.05-34.63",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2130.1 2207.4c4.93 7.59 22.56 7.16 33.95-4.72 15.24-15.9 17.31-49.81-16.77-33.65-13.03 6.18-25.9 24.95-17.18 38.37",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2290.67 2196.33c-38.38 18.44-55.72 70.04-40.5 115.88 15.77 14.5 34.93 23.07 55.64 23.07 43.74 0 80.73-37.96 92.97-90.18-.54-8.39-2.1-16.45-5.27-23.81-13.84-32.13-57.88-46.55-102.84-24.96",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305.81 2152.37c-48.46 0-82.58 15.72-96.06 34.62-.81 6.64-1.23 13.45-1.23 20.39 0 43.42 16.49 81.71 41.65 104.83-15.22-45.84 2.12-97.44 40.5-115.88 44.96-21.59 89-7.17 102.84 24.96 3.17 7.36 4.73 15.42 5.27 23.81 2.8-11.92 4.32-24.59 4.32-37.72 0-6.94-.43-13.75-1.24-20.39-13.74-18.06-47.6-34.62-96.05-34.62",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2315.83 2314.03c4.93 7.58 22.57 7.15 33.95-4.72 15.25-15.91 17.32-49.81-16.77-33.66-13.02 6.19-25.9 24.97-17.18 38.38",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2277.94 1995.89c-38.38 18.44-55.71 70.04-40.5 115.88 15.78 14.5 34.93 23.07 55.64 23.07 43.74 0 80.72-37.96 92.98-90.18-.55-8.39-2.11-16.45-5.29-23.81-13.83-32.13-57.87-46.56-102.83-24.96",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2293.08 1951.93c-48.46 0-82.58 15.72-96.06 34.62-.81 6.64-1.23 13.45-1.23 20.39 0 43.42 16.5 81.71 41.65 104.83-15.21-45.84 2.12-97.44 40.5-115.88 44.96-21.6 89-7.17 102.83 24.96 3.18 7.36 4.74 15.42 5.29 23.81 2.79-11.92 4.3-24.59 4.3-37.72 0-6.94-.41-13.75-1.22-20.39-13.75-18.06-47.61-34.62-96.06-34.62",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2303.1 2113.59c4.93 7.58 22.57 7.15 33.96-4.72 15.24-15.91 17.31-49.81-16.77-33.66-13.04 6.18-25.91 24.97-17.19 38.38",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2463.68 2102.52c-38.39 18.44-55.73 70.03-40.51 115.88 15.78 14.49 34.93 23.06 55.64 23.06 43.74 0 80.73-37.95 92.97-90.17-.54-8.39-2.09-16.45-5.27-23.82-13.84-32.12-57.88-46.54-102.83-24.95",
    style: {
      fill: "#ffcebb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2478.81 2058.55c-48.45 0-82.58 15.72-96.06 34.63-.8 6.64-1.22 13.45-1.22 20.38 0 43.42 16.49 81.71 41.64 104.84-15.22-45.85 2.12-97.44 40.51-115.88 44.95-21.59 88.99-7.17 102.83 24.95 3.18 7.37 4.73 15.43 5.27 23.82 2.8-11.93 4.32-24.59 4.32-37.73 0-6.93-.42-13.74-1.23-20.38-13.75-18.06-47.61-34.63-96.06-34.63",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2488.84 2220.22c4.93 7.58 22.56 7.15 33.94-4.73 15.25-15.9 17.32-49.8-16.77-33.65-13.03 6.18-25.9 24.96-17.17 38.38",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1732.87 2396.07.3-.71c-34.4-25.96-40.15-63.33-46.74-102.89l-.93.14c-2.15 35.25 14.9 90.04 47.37 103.46M1565.02 2493.28l.31-.72c-34.4-25.96-40.15-63.34-46.74-102.88l-.93.12c-2.15 35.24 14.89 90.05 47.36 103.48M1918.6 2503.03l.3-.72c-34.39-25.95-40.15-63.32-46.73-102.88l-.93.13c-2.15 35.26 14.9 90.05 47.36 103.47M1750.76 2600.23l.3-.72c-34.4-25.96-40.15-63.33-46.74-102.88l-.93.13c-2.15 35.25 14.9 90.05 47.37 103.47M2068.7 2208.29l.3-.73c-34.39-25.95-40.15-63.33-46.73-102.87l-.93.13c-2.15 35.24 14.89 90.03 47.36 103.47M2243.33 2115.46l.31-.73c-34.4-25.95-40.15-63.33-46.74-102.87l-.93.12c-2.15 35.25 14.9 90.05 47.36 103.48M1900.86 2305.48l.3-.72c-34.4-25.95-40.15-63.33-46.74-102.88l-.93.12c-2.15 35.26 14.9 90.06 47.37 103.48M2254.43 2315.25l.3-.73c-34.4-25.95-40.14-63.33-46.73-102.87l-.93.12c-2.15 35.25 14.89 90.05 47.36 103.48M2429.07 2222.6l.3-.72c-34.4-25.96-40.16-63.34-46.74-102.89l-.92.13c-2.16 35.25 14.89 90.05 47.36 103.48M2086.59 2412.44l.3-.72c-34.4-25.96-40.15-63.33-46.74-102.88l-.92.13c-2.16 35.25 14.89 90.04 47.36 103.47",
    style: {
      fill: "#d8a293",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2179.74 1995.15c-2.79 6.39-3.49 13-5.17 19.68-1.17 4.64-8.51 4.82-9.57 0-2.98-13.49 2.5-36.94 16.74-42.08 3.88-1.4 6.59 2.7 6.04 6.05-1.02 6.19-5.54 10.61-8.04 16.35M2151.46 2037.94c-7.89-1.74-14.28-7.09-22.05-9.49-6.76-2.1-13.77-2.1-20.09-5.43-1.78-.94-1.4-3.22 0-4.24 12.64-9.26 40.37-1.21 47.48 12.21 1.99 3.74-1.27 7.85-5.34 6.95M1819.55 2212.71c-4.88-1.9-8.77-5.11-13.52-7.32-4.94-2.3-10.26-3.77-15.22-6.04-1.25-.57-.98-2.34 0-2.99 10.79-7.07 28.53-2.63 34.4 9 1.76 3.49-1.25 9.07-5.66 7.35M1853.42 2431.57c-10.29-2.45-13.63-13.98-14.27-23.43-.17-2.37 1.42-4.85 3.43-5.99l1.65-.93c1.17-.67 2.68-.72 3.85 0 4.58 2.81 4.41 5.31 5.62 10.41 1.32 5.62 4.33 10.27 4.79 16.08.22 2.7-2.72 4.42-5.07 3.86M1659.55 2312.67c-5.9 3.94-9.59.89-15.66-1.8-9.72-4.32-19.3-6.74-29.88-8.01-1.54-.19-2.09-2.38-.39-2.86 13.85-3.94 28.77-4 42.35 1.13 3.14 1.19 4.87 3.43 5.15 6.76l.14 1.79c.1 1.25-.75 2.35-1.71 2.99M2192.94 2245.16c-4.31 1.49-6.4.57-10.48-1.39-5.8-2.77-11.57-4.62-17.54-6.86-2.28-.84-3.11-3.44-1.41-5.32 8.53-9.41 31.54-3.06 31.91 10.32.04 1.55-1.1 2.77-2.48 3.25M2017.73 2334.44c-6.05-1.95-11.27-3.48-17.65-4.26-1.95-.24-3.45-2.6-1.74-4.2 6.71-6.29 17.54-5.73 23.56 1.31 2.57 3.02.2 8.57-4.17 7.15M2470.72 2043.51c-6.22 1.04-11.65-1.25-17.89-1.63-6.99-.44-13.81 1.41-20.8 1.25-1.42-.04-2.62-1.71-1.73-3.01 8.13-11.91 34.78-14.75 41.94-.35.66 1.32.22 3.45-1.52 3.74M2419.5 2031.32c-1.88 1.16-4.63-.77-3.87-2.97 1.97-5.73 3.79-12.13 4.06-18.22.22-4.79-.65-7.9 1.85-12.18.99-1.68 3.41-2.43 5.11-1.33 12.94 8.35 3.16 28.43-7.15 34.7",
    style: {
      fill: "#c6aaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.79 2538.81c-1.27 6.74.61 12.79 1.6 19.38.3 1.99-1.53 3.73-3.48 2.68-13.12-7.11-15.29-36.99 1.08-41.27 2.69-.69 5.6 1.34 5.53 4.22-.14 5.68-3.68 9.41-4.73 14.99M1653.85 2394.63c-7.22-1.12-13.33-5.03-20.48-6.29-7.15-1.26-14.13.22-21.3-.32-1.22-.09-2.25-1.43-1.49-2.6 9.84-15.18 41.52-12.29 47.18 5.29.82 2.54-1.68 4.27-3.91 3.92M1755.97 2347.61c-.31 2.55-3.34 4.44-5.44 2.25-9.57-10.04-5.87-27.7 6.01-33.86 2.24-1.15 4.95.75 4.28 3.29-2.5 9.63-3.64 18.53-4.85 28.32M1979.31 2426.88c-7.08-.68-13.86-2.99-21.04-2.45-6.22.47-11.99 2.7-18.24 3.17-.94.07-1.48-.92-1.31-1.72 3.86-18.91 34.69-19.67 44.44-5.7 1.85 2.64-.58 7.02-3.85 6.7M2118.98 2341.75c1.26 5.09-6 8.48-8.65 3.65-6.5-11.88-7.17-30.89 6.44-38.22 3.5-1.9 7.66 1.22 6.68 5.13-2.64 10.54-7.26 18.13-4.47 29.44M2005.01 2212.46c-14.05-5.49-28.08-6.32-42.96-7.2-2.53-.14-4.49-3.51-2.26-5.44 15.39-13.22 37.67-7.32 48.91 7.83 1.65 2.22-1.11 5.82-3.69 4.81M2101.84 2128.59c-1.79 6.23-1.12 12.03.41 18.23.98 3.97-4.52 8.06-7.45 4.35-7.85-9.92-10.26-36.44 7.14-38 1.75-.16 2.99 1.55 3.1 3.09.33 4.65-1.95 7.98-3.2 12.33M2355.97 2218.15c-8.34-2.01-16.13-5.47-24.82-5.96-7.81-.44-15.1 1.49-22.79 2.25l-1.01-1.78c11.52-16.02 41.36-14.58 52.01 1.07 1.56 2.28-1 4.99-3.39 4.42M2496.32 2112.64c-4.35 7.37-8.28 13.06-10.12 21.63-.29 1.3-1.87 1.46-2.74.73-9.94-8.4-5.44-26.67 7.31-29.58 4.09-.94 7.81 3.4 5.55 7.22M2330.46 2025.16c-6.2-.6-11.88-2.84-18.23-1.79-6.09 1.01-11.81 4.22-17.06 7.3-1.66.97-3.7-.63-3.21-2.47 4.37-16.16 30.03-24.25 41.98-11.43 2.65 2.84 1.02 8.83-3.48 8.39",
    style: {
      fill: "#edb7a6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2350.1 2704.05-494.27-285.36-405.1 233.89 494.26 285.36 405.11-233.89",
    style: {
      fill: "#6ca5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2350.1 2704.05v-125.52l-494.27-285.37v125.53l494.27 285.36",
    style: {
      fill: "#488bed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1450.73 2652.58v-125.54l405.1-233.88v125.53l-405.1 233.89",
    style: {
      fill: "#2c7ddd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1669.2 2504.14v-23.13l171.13-98.23v23.13l-171.13 98.23M1669.2 2458.99v-23.13l171.13-98.23v23.13l-171.13 98.23M1643.95 2518.72l-173.72 100.3v-77.87l173.72-100.3v77.87M2228.52 2609.51l-196.13-111.58v-77.88l196.13 111.6v77.86M2246 2619.61v-77.87l81.19 46.87v77.87l-81.19-46.87",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2016.46 2733.96c-9.69.87-20.95.97-31.59-.85-13.41 4.18-31.36 6.81-46.05 6.38-47.47-1.39-98.43-43.4-128.88-81.82-10.34 5.57-18.47 10.89-30.36 11.79-6.66 18.52-27.39 33.62-47.99 32.43 12.07-9.97 18.03-23.47 23.78-35.46-30.65-8.01-61.79-41.52-57.34-64.91-25.9-1.1-49.15-.52-61.66 16.45-7.28-28.49 29.94-44.42 58.33-45.38 3.19-.11 6.71.11 10.39.6.33-.52 56.31-56.92 87.6-55.75 17.67.66 23.18 3.41 36.9 23 6.8 9.72 5.76 14.83 6.91 19.21 13.07-3.37 26.79-4.13 40.18-2.47 4.57-2.99 9.2-5.91 13.75-8.91 13.52-8.92 27.43-20.38 42.2-27.22 13.79-6.39 54.74 16.48 40.52 34.85-7.14 9.23-16.35 20.42-27.79 29.69 4.27 2.74 13.57 9.24 17.74 12.14 8.09-7.06 11.74-13.96 20.38-20.38 13.96-10.39 22.35-18.93 36.9-4.38 13.21 13.22 4.7 22.96-4.87 34.06-4.95 5.74-15.32 17.69-15.13 17.83 8.23 5.65 19.96 16.41 22.43 14.62 9.7-7.04 18.06-17.37 27.18-24.27 19.9-15.05 38.36 2.91 33.99 13.27-5.59 13.24-18.68 30.9-26.48 41.62-12.99 17.84-28.73 36.5-47.9 48.54a72.634 72.634 0 0 1-7.8 6.23c10.8-.29 39.56 2.39 65.18-20.82-2.91-18.45 21.17-25.12 31.56-31.07 2.91 30.1-50.39 58.11-82.08 60.98",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1841.28 2691.16c22.03-39.3 118.45-54.95 129.37-3.41 3.38 15.94-5.06 39.34-19.13 51.82-5.28 4.68-68.53-2.02-110.24-48.41M1788.58 2637.67c-13.58 6.1-31.17 6.27-39.91-7.36-12.12-18.89 7.65-41.73 24.29-49.06 16.63-7.33 40.61-5.44 43.15 16.4 1.95 16.86-11.02 35.44-27.53 40.02M1868.5 2615.55c-9.43-19.67 20.47-28.62 34.6-26.48 17.81 2.69 50.5 20.61 49.86 42.06-.45 15.15-74.4 5.4-84.46-15.58",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1802.74 2757.71.81-.47.63.34c-.67 2.88-1.25 5.76-1.81 8.67-.55 2.92-1.2 5.84-2.01 8.75-.77 2.92-1.76 5.84-2.96 8.71-1.18 2.88-2.75 5.8-4.72 8.71-.3.39-.95.78-2.11 1.2-1.11.39-1.84.44-2.22.13-1.42-1.11-2.28-2.62-2.34-4.59-.16-1.88.19-4.03.96-6.35.82-2.36 1.93-4.8 3.4-7.37 1.4-2.58 2.93-4.99 4.49-7.3 1.6-2.32 3.05-4.37 4.47-6.23 1.46-1.88 2.62-3.25 3.41-4.2zm13.66 2.45c2.06 1.16 4.72 2.28 7.98 3.25 3.31 1 6.96 1.64 10.81 1.94 3.85.3 7.88.13 11.89-.47 4.12-.65 7.91-2.02 11.45-4.12 2.34-1.46 4.42-3.43 6.22-5.92 1.84-2.49 3.22-5.28 4.25-8.37.96-3.05 1.58-6.26 1.8-9.56.26-3.31.05-6.52-.66-9.66-.76-3.08-1.89-5.96-3.5-8.49-1.59-2.58-3.73-4.63-6.43-6.18-1.1-.64-2.54-1.2-4.17-1.72-1.71-.51-3.49-.94-5.4-1.24-1.87-.34-3.7-.56-5.41-.68-1.71-.18-3.13-.18-4.25 0-1.75.17-3.06.47-3.99.94l-2.05 1.5-1.29 1.76c-.39.56-.99 1.12-1.89 1.63 2.1.09 4.25.3 6.46.6s4.14.81 5.77 1.58c1.8.86 3.45 2.36 4.96 4.51 1.43 2.19 2.63 4.63 3.56 7.47.96 2.79 1.52 5.7 1.69 8.75.24 3.04-.11 5.93-.95 8.58-.85 2.7-2.25 5.02-4.2 6.99-1.93 1.93-4.59 3.17-7.94 3.65-3.3.47-6.37.3-9.14-.43-2.79-.78-5.01-1.84-6.75-3.3-.62-.65-1.26-1.63-1.89-2.97-.62-1.41-1.18-2.83-1.61-4.33-.43-1.5-.68-2.95-.68-4.33-.09-1.42.08-2.45.47-3.13.3-.56 1.59-1.5 3.86-2.88 2.27-1.32 4.72-2.79 7.4-4.38 2.68-1.58 5.17-3.12 7.42-4.58 2.3-1.5 3.69-2.62 4.01-3.39l-.51-1.58c-.67-.39-1.66-.66-2.97-.82-1.2-.18-2.55-.34-4.04-.43-1.45-.04-2.86-.13-4.06-.22-4.46 2.41-9.22 5.15-14.46 8.28-5.17 3.13-10.49 6.4-16 9.83-5.47 3.43-10.98 6.95-16.56 10.51-5.58 3.56-11.01 7.04-16.39 10.38-5.38 3.39-10.53 6.57-15.44 9.53-4.98 3-9.52 5.57-13.61 7.8 1.06 1.68 2.56 2.79 4.41 3.39 1.82.6 3.83.82 6 .64 2.21-.21 4.4-.72 6.69-1.63 2.3-.9 4.45-2.06 6.44-3.42 3.5-2.58 6.67-4.94 9.5-7 2.75-2.1 5.58-4.16 8.37-6.22 2.83-2.01 5.79-4.2 8.83-6.39 3.15-2.24 6.8-4.81 11.03-7.73 1.24-.81 2.14-1.11 2.79-.89l.51.89c-2.01 1.46-4.42 3.56-7.24 6.22-2.79 2.66-5.58 5.67-8.46 8.88a123.22 123.22 0 0 0-8 10.17c-2.49 3.52-4.53 6.87-6.03 9.95-1.46 3.14-2.19 5.97-2.25 8.46-.11 2.49.92 4.33 2.96 5.53.6.35 1.82.82 3.58 1.51 1.76.63 3.86 1.16 6.27 1.54 2.44.35 5.05.39 7.93.08 2.92-.29 5.69-1.2 8.43-2.78 2.83-1.63 5.17-3.57 6.97-5.8 1.76-2.18 3.23-4.5 4.21-6.94 1.05-2.45 1.76-4.9 2.19-7.43.43-2.53.71-4.89.82-7.12.16-2.23.19-4.25.14-6.01-.02-1.79.02-3.17.15-4.2M1900.76 2804.14c7.75-8.84 13.18-15.8 16.35-20.77 3.2-5.02 3.42-8.28.71-9.87-1.98-1.2-4.25-1.76-6.86-1.63-2.62.13-5.34.68-8.28 1.68-2.88.98-5.96 2.27-9.1 3.9-3.13 1.63-6.26 3.39-9.46 5.28l-1.52.42v-.94c.79-.77 1.83-1.89 3.09-3.3 1.2-1.42 2.51-2.92 3.9-4.55 1.42-1.63 2.74-3.3 4.03-5.02 1.27-1.72 2.37-3.35 3.26-4.85.91-1.5 1.53-2.78 1.89-3.86.34-1.03.26-1.76-.29-2.05-.82-.48-1.83-.95-3.1-1.43-1.22-.51-2.57-.89-3.99-1.15-1.37-.31-2.87-.43-4.37-.39-1.59 0-3.07.3-4.51.77-4.71 1.76-9.3 3.95-13.85 6.69-4.51 2.71-8.63 5.59-12.29 8.54-3.67 3.01-6.8 5.97-9.36 8.88-2.51 2.92-4.18 5.41-4.95 7.51l1.67.6c.82.26 1.72.52 2.7.69.94.17 1.87.3 2.72.34.91.05 1.49-.04 1.92-.26.73-.98 2.1-2.44 4.07-4.29a90.41 90.41 0 0 1 6.91-5.96c2.66-2.14 5.45-4.29 8.49-6.43a100.9 100.9 0 0 1 8.56-5.67c2.77-1.63 5.24-2.83 7.49-3.61 2.14-.76 3.77-.84 4.8-.24.48.24 0 1.4-1.41 3.39-1.44 2-3.3 4.36-5.75 7.15-2.4 2.84-5.06 5.84-7.89 8.98-2.84 3.17-5.41 6.04-7.81 8.7-2.41 2.67-4.36 4.81-5.8 6.43-1.41 1.68-1.92 2.41-1.43 2.23l1.46 1.08c.87.47 1.97.86 3.11 1.21 1.14.34 2.27.59 3.45.72 1.14.09 2.04-.04 2.73-.43.08-.04.98-.73 2.74-2.06 1.72-1.29 3.91-2.91 6.56-4.89 2.65-1.97 5.54-4.03 8.73-6.22 3.16-2.18 6.23-4.12 9.1-5.83 2.94-1.72 5.58-3.09 7.85-4.04 2.34-.94 4.01-1.16 4.98-.6.47.26.51.94.1 2.02-.37 1.12-1 2.4-1.92 3.95-.84 1.5-1.89 3.17-3.14 4.97-1.24 1.85-2.53 3.61-3.77 5.32a92.115 92.115 0 0 1-3.73 4.73c-1.2 1.41-2.15 2.48-2.88 3.25.41.22 1.12.52 2.23.86 1.05.39 1.71.39 1.86.05",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944.38 2786.97c-.95.82-2.13 2.15-3.67 3.99-1.54 1.81-3.28 3.87-5.17 6.23-1.98 2.31-4.01 4.8-6.23 7.41-2.16 2.62-4.33 5.24-6.51 7.85l-1.08.91-1.23 1.03c-3.91 2.65-8.03 5.49-12.3 8.62-4.27 3.04-8.73 6.39-13.36 9.95l-1.5.87-1.76-.44c-.26-.21-1.29-1.07-3.13-2.53-1.76-1.46-3.89-3.18-6.25-5.19l-.12-.6.27-.64c4.29-3.44 8.84-6.91 13.77-10.47 4.94-3.52 10-7 15.19-10.39 5.15-3.34 10.4-6.56 15.83-9.61 5.41-3.04 10.77-5.74 16.05-8.06h1.34zm-32.09 68.3c.77-.04 1.84-.25 3.26-.68 1.45-.48 2.53-.95 3.26-1.55-.63-.34-1.57-.94-2.87-1.8-1.31-.86-2.75-1.8-4.17-2.87-1.48-1.08-2.97-2.2-4.52-3.36-1.53-1.1-2.73-2.22-3.63-3.17l.22-.64.57-.52c1.7-1.45 3.8-3.21 6.16-5.27 2.43-2.06 5.13-4.21 8.17-6.52 3.05-2.32 6.27-4.73 9.65-7.17 3.42-2.49 6.94-4.85 10.62-7.12a237.1 237.1 0 0 1 10.95-6.39c3.6-1.97 7.2-3.61 10.72-4.94l1.28.14-.15.94c-.81.85-1.9 2.14-3.27 3.73-1.25 1.55-2.84 3.39-4.49 5.49-1.76 2.11-3.54 4.34-5.43 6.78-1.89 2.4-3.86 4.89-5.74 7.42-.94 1.25-1.42 2.15-1.46 2.75l.7 1.03 1.96-.43 2.05-1.37c3.35-3.57 6.61-7.04 9.84-10.39 3.21-3.34 6.09-6.38 8.66-9.17 2.57-2.75 4.67-5.11 6.37-7.04 1.63-1.94 2.55-3.31 2.72-3.99l.24-2.15-.54-2.1-1.42-1.59-2.06-.68c-8.27 0-18.07 3.13-29.42 9.35-.93.42-1.59.55-2 .38l.35-1.19c2.44-2.49 4.78-4.86 6.96-7.09 2.19-2.18 4.13-4.2 5.82-6 1.65-1.76 3.02-3.3 4.07-4.51 1.05-1.24 1.68-2.14 1.91-2.65l.58-2.32-.32-2.27-1.24-1.68c-.6-.43-1.34-.6-2.32-.51-4.48.47-9.91 1.97-16.3 4.55-6.39 2.52-13.21 5.78-20.51 9.69-7.29 3.94-14.71 8.37-22.38 13.3-7.63 4.89-14.86 9.95-21.68 15.14l-1.14.3-.94-.04c-2.43-1.89-4.42-3.52-6.15-4.89-1.74-1.33-2.71-2.15-2.97-2.4l-2.18-.34-1.68 1.32-.86 2.06.35 1.8c.17.26 1.03.99 2.61 2.19 1.57 1.16 3.52 2.62 5.78 4.42l.15.6-.31.65c-5.53 4.5-10.44 8.88-14.81 13.08-4.38 4.21-7.84 8.11-10.41 11.67.49.3 1.24.56 2.27.82 1.1.25 2.28.42 3.54.6 1.31.17 2.62.25 3.99.21 1.39 0 2.58-.13 3.59-.39 2.05-1.97 4.9-4.58 8.47-7.81 3.62-3.17 7.82-6.73 12.68-10.64l1.07-.34.94.13c1.37 1.08 2.66 2.11 3.95 3.05 1.29.95 2.36 1.8 3.3 2.61.99.78 1.76 1.42 2.44 1.89l1.12.99-.38.95-.6.94-1.05.77c-.88.69-1.91 1.63-3.23 2.83-1.26 1.2-2.63 2.53-4.15 4.03-1.54 1.46-2.9 2.88-4.21 4.21-1.22 1.37-2.29 2.53-3.02 3.51-.82 1.04-1.1 1.68-.95 1.94.47.3 1.27.55 2.27.85 1.01.26 2.15.48 3.42.65 1.24.17 2.49.3 3.77.34 1.22.09 2.34 0 3.28-.22.48 0 1.38-.6 2.79-1.88 1.31-1.29 2.83-2.75 4.38-4.29 1.65-1.59 3.2-3 4.64-4.33 1.54-1.34 2.6-2.02 3.33-2.02.44.08 1.23.56 2.41 1.5 1.11.94 2.36 1.93 3.74 3.01 1.36 1.02 2.71 2.01 4.15 2.83 1.38.85 2.54 1.28 3.44 1.28",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1955.94 2845.7c-1.22.95-2.66 1.55-4.27 1.76-1.63.26-3.05-.08-4.23-.94-1.45-1.76-1.95-3.56-1.41-5.49.54-1.93 1.61-3.65 3.15-5.19l1.44-.69 1.41.13 1.25.56.88.56c1.7 1.54 2.64 3.21 2.83 5.06.19 1.85-.13 3.26-1.05 4.24zm28.03 4.98c.63-1.28 1.36-2.87 2.32-4.72.9-1.88 1.8-3.9 2.72-6.09.93-2.18 1.74-4.38 2.39-6.65.64-2.23.98-4.42 1.07-6.56.09-2.11-.26-4.04-1.03-5.8-.75-1.75-2.1-3.17-3.99-4.29-1.85-1.03-4.12-1.89-6.87-2.44-2.78-.61-5.68-.95-8.7-.95-3.09 0-6.12.34-9.14 1-3.05.64-5.75 1.66-8.07 3-2.4 1.41-4.82 2.99-7.21 4.8-2.36 1.8-4.5 3.69-6.43 5.67-1.89 1.97-3.56 3.99-4.87 6.04-1.33 2.06-2.17 4.12-2.55 6.1-.28 1.97 0 3.86.81 5.61.84 1.72 2.45 3.31 4.9 4.72.27.18 1.05.39 2.25.69 1.17.25 2.63.47 4.35.56 1.76.08 3.7 0 5.84-.26 2.14-.26 4.31-.81 6.54-1.71 2.25-1.08 3.65-2.45 4.14-4.17.57-1.71.56-3.47-.04-5.28-.54-1.75-1.42-3.42-2.62-4.97-1.16-1.54-2.41-2.66-3.65-3.39-.6-.34-.38-.99.61-2.02.98-1.03 2.31-2.1 3.94-3.21 1.63-1.16 3.26-2.2 4.93-3.22 1.63-.99 2.84-1.68 3.52-2.06 1.63-.94 3.67-1.54 5.96-1.72 2.36-.16 4.68.39 6.91 1.67 1.42.82 2.36 2.07 2.83 3.66.43 1.63.61 3.38.46 5.35-.11 1.98-.5 3.99-1.06 6.05-.62 2.07-1.2 3.95-1.78 5.67-.66 1.71-1.18 3.18-1.78 4.33-.56 1.2-.77 1.85-.85 2.06l.64.86.57 1.15.93.95 1.63.26.38-.69",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1967.89 2857.94 1.16-.22 1.67-.05 1.33.34.08 1-1.58 1.88-2.24 1.89c-2.27 1.85-3.99 2.74-5.06 2.7-1.07-.04-1.24-.55-.53-1.58.58-.91 1.24-1.81 1.99-2.62.65-.82 1.72-1.93 3.18-3.34zm-5.49 15.52c.6-.13 1.58-.77 3.05-2.06 1.37-1.24 2.91-2.7 4.54-4.33 1.61-1.63 3.18-3.3 4.57-4.93 1.48-1.68 2.47-2.97 3.05-3.91l.29-.22.37-.04c1.78-.16 3.45-.16 5.09.04 1.56.22 3.21.39 4.87.48 1.58.13 3.25.17 4.96.08 1.68-.08 3.57-.47 5.54-1.15 1.97-.64 4.08-1.89 6.36-3.65 2.27-1.8 4.58-3.77 7.09-6.05 2.43-2.23 4.85-4.54 7.27-6.91 2.36-2.36 4.68-4.46 6.81-6.35 2.05-1.8 3.96-3.26 5.64-4.2 1.67-.95 3-1.2 3.96-.64.67.38.75 1.42.17 3.08-.56 1.68-1.54 3.65-2.93 6.06a116.42 116.42 0 0 1-4.98 7.76c-1.97 2.79-3.99 5.53-6.16 8.19-2.12 2.62-4.22 5.07-6.32 7.34-2.04 2.23-3.87 3.99-5.41 5.28l.09.64 1.28.73 1.89.22 1.78-.86c1.31-1.2 3.11-3.05 5.39-5.45a216.4 216.4 0 0 0 7.16-7.98c2.49-2.97 4.98-6.01 7.4-9.18 2.46-3.18 4.48-6.13 6.09-8.88 1.7-2.74 2.73-5.15 3.2-7.26.51-2.05.13-3.47-1.16-4.24-.96-.52-2.23-1.03-3.78-1.5-1.52-.52-3.17-.82-4.93-.99-1.8-.12-3.65-.05-5.6.26-1.95.3-3.86.98-5.79 2.1-2.75 1.55-5.38 3.52-8.06 5.84-2.68 2.31-5.09 4.59-7.27 6.86-2.21 2.23-4.08 4.29-5.71 6.14-1.54 1.84-2.71 3.08-3.45 3.77-.76.82-1.68 1.46-2.75 1.93-1.05.43-2.43.52-4.06.21-.53 0-1.97-.17-4.37-.47-2.4-.3-5.13-.51-8.17-.6-3.09-.09-6.16-.04-9.21.18-3.06.25-5.49.89-7.24 1.92-1.27.82-2.94 2.23-4.9 4.3-2.01 2.06-3.86 4.28-5.45 6.73-1.63 2.4-2.72 4.76-3.47 7.08-.65 2.32-.3 4.08 1.07 5.32.69.38 1.55.64 2.62.77s2.17.17 3.33.09c1.15-.05 2.25-.22 3.32-.52 1.07-.26 2.06-.6 2.92-1.03",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2316.53 2509.71c-3.44 2.35-6.87 4.7-10.54 6.87-53.72 31.7-140.65 40.9-200.34 13.01-77.26-36.11-127.6-127.33-96.74-233.52 1.35-4.69 2.64-9.35 4.32-14.09 30.36-85.53 111.27-128.46 187.25-126.74 84.75 1.91 153.36 48.64 180.05 134.41 27.21 87.43 5.8 172.3-64 220.06",
    style: {
      fill: "#701b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200.48 2155.23c84.75 1.92 153.36 48.65 180.05 134.42 27.21 87.43 5.8 172.3-64 220.06 31.13-71.99 18-157.19-55.55-206.01-73.06-48.47-177.18-52.94-252.07-7.63 1.35-4.69 2.64-9.35 4.33-14.09 30.35-85.53 111.26-128.46 187.24-126.75",
    style: {
      fill: "#dd1e10",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2159.75 2608.59s-3.1-42.23 12.98-71.3c16.09-29.07 66.88-20.44 66.88-20.44s1.16 29.03-16.16 54.11c-17.32 25.09-63.7 37.63-63.7 37.63",
    style: {
      fill: "#70bc2e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235.54 2502c-25.39 4.68-56.33 16.62-71.29-1.07-21.06-24.93 17.85-46.18 37.31-52.66 24.48-8.15 76.75-12.22 87.46 17.54 8.71 24.2-32.7 32.36-53.48 36.19",
    style: {
      fill: "#dd1e10",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2268.86 2589.38c-6.65 2.28-13.95-.49-17.37-6.63-10.24-18.42-30.72-56.97-37.98-83.07-2.44-8.76-4.26-16.24-5.63-22.57 4.58-4.31 9.43-6.79 17.56-6.15 2.2.18 4.38.57 6.54 1.11 3.38 19.23 10.1 41.6 18.57 56.56 8.59 15.17 18.41 35.62 23.98 47.52 2.44 5.23-.22 11.35-5.67 13.23",
    style: {
      fill: "#2c1d1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2235.83 2517.17c7.57-27.02 50.24-26.68 73.4-17.72 24.35 9.42 40.63 39.89 48.41 64.56-48.41 7.41-102.97-14.46-121.81-46.84",
    style: {
      fill: "#7dd13d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2125.17 2485.76c-32.39 23.18-73.05-7.02-88.14-35.56-15.26-28.92-23.16-80.86 17.69-93.06 36.04-10.76 80.22 28.49 86.61 62.39 3.47 18.46 8.63 48.49-16.16 66.23",
    style: {
      fill: "#ff4133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2098.8 2478.03c-18.92 13.53-42.66-4.1-51.47-20.77-8.91-16.89-13.53-47.22 10.33-54.34 21.05-6.28 46.84 16.64 50.57 36.43 2.03 10.79 5.05 28.32-9.43 38.68",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2894.9 2781.25-476.02-274.83c-61.25-35.37-168.98-30.69-240.18 10.39l-1068.81 617.08c-35.56 20.54-55.96 47.11-55.96 72.93 0 20.59 13.48 39.71 37.98 53.86l483.69 279.25v23.76l-493.97-285.2c-31.13-17.98-48.27-43.43-48.27-71.66 0-33.37 24.14-66.44 66.25-90.76l1068.81-617.08c41.91-24.18 95.72-36.57 146.87-36.57 42.66 0 83.44 8.62 113.87 26.18l465.74 268.9v23.75M2976.19 2779.07l-60.01 34.65v-23.76l49.72-28.71c35.58-20.54 55.97-47.13 55.97-72.94 0-20.58-13.48-39.7-37.98-53.85l-67.71-39.09v-23.75l77.99 45.03c31.14 17.96 48.27 43.42 48.27 71.66 0 33.36-24.14 66.44-66.25 90.76",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2894.9 2583.09-476.02-274.84c-61.25-35.37-169.02-30.72-240.18 10.4l-1068.81 617.08c-35.56 20.54-55.96 47.11-55.96 72.93 0 20.59 13.48 39.71 37.98 53.85l483.69 279.26v23.76l-493.97-285.2c-31.13-17.98-48.27-43.43-48.27-71.66 0-33.37 24.14-66.45 66.25-90.76l1068.81-617.07c41.91-24.21 95.72-36.58 146.87-36.58 42.64 0 83.44 8.62 113.87 26.19l465.74 268.89v23.75",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2418.88 2110.08c-61.25-35.33-168.98-30.69-240.18 10.39l-1068.81 617.1c-35.56 20.53-55.96 47.11-55.96 72.93 0 20.58 13.48 39.71 37.98 53.85l127.64 73.7v23.75l-137.92-79.63c-31.13-17.98-48.27-43.43-48.27-71.67 0-33.37 24.14-66.44 66.25-90.75l1068.81-617.08c41.91-24.21 95.75-36.58 146.87-36.58 42.66 0 83.44 8.62 113.88 26.19l465.73 268.89v23.76l-476.02-274.85M2976.19 2580.9l-60.01 34.65v-23.76l49.72-28.71c35.58-20.53 55.97-47.11 55.97-72.93 0-20.58-13.48-39.71-37.98-53.85l-67.71-39.09v-23.75l77.99 45.02c31.14 17.97 48.27 43.42 48.27 71.67 0 33.37-24.14 66.44-66.25 90.75",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2976.19 2382.74-60.01 34.64v-23.75l49.72-28.71c35.58-20.53 55.97-47.12 55.97-72.92 0-20.59-13.48-39.72-37.98-53.88l-67.71-39.09v-23.74l77.99 45.04c31.14 17.97 48.27 43.42 48.27 71.67 0 33.36-24.14 66.43-66.25 90.74",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2418.88 1911.93c-61.25-35.38-168.98-30.71-240.18 10.39l-1068.81 617.09c-35.56 20.52-55.96 47.11-55.96 72.93 0 20.58 13.48 39.71 37.98 53.84l127.64 73.69v23.76L1081.63 2684c-31.13-17.97-48.27-43.42-48.27-71.66 0-33.37 24.14-66.45 66.25-90.75l1068.81-617.07c41.91-24.21 95.72-36.6 146.87-36.6 42.66 0 83.44 8.63 113.88 26.22l530.65 303.96v28.4l-540.94-314.57",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2958.59 2054.98h-20.57v742.48h20.57v-742.48M2797.72 1968.34h-20.57v742.49h20.57v-742.49M2634.41 1865.49h-20.57v742.48h20.57v-742.48M2471.11 1775.29h-20.57v742.48h20.57v-742.48M1152.43 2360.91h-20.57v742.48h20.57v-742.48M1315.73 2258.05l-20.57 6.21v736.28h20.57v-742.49M1479.03 2179.14h-20.56v742.49h20.56v-742.49M1642.35 2076.29h-20.57v742.48h20.57v-742.48M1803.22 1989.68h-20.57v742.47h20.57v-742.47M1966.54 1886.82h-20.58v742.48h20.58v-742.48M2129.83 1796.6h-20.57v742.48h20.57V1796.6M2293.15 1730.13h-20.57v742.48h20.57v-742.48",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2447.11 2522.08v-591.6l512.71 296.02v591.59l-512.71-296.01",
    style: {
      fill: "#701b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160.77 1760.92 1009.11 3389.33c-18.692 28.39-28.641 40.14-28.641 56.71-.016 16.3 13.375 27.45 24.611 33.93l215.42 121.79c-3.96 8.31-8.04 16.59-12.06 24.88l-217.155-122.77c-24.773-14.3-38.418-34.85-38.406-57.83 0-25.96 13.84-45.85 37.168-77.52l1125.523-1581.5c8.01-4.63 32.06-20.23 45.2-26.1",
    style: {
      fill: "#d8c4c3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1596.09 3891.54c5.41 2.57 12.23 2.03 19.64-2.25 17.53-10.12 31.73-37.27 31.73-60.64 0-12.99-4.49-21.89-11.4-25.66l-295.88-173.08-300.07-173.66-38.93 89.07 594.91 346.22",
    style: {
      fill: "#701b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.46 3482.02c0-23.37-14.21-34.11-31.74-23.99-17.52 10.11-31.732 37.26-31.732 60.63 0 23.37 14.212 34.11 31.732 23.99 17.53-10.11 31.74-37.26 31.74-60.63",
    style: {
      fill: "#dd1e10",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.05 3513.63c1.6.94 3.63 1 5.91-.32 5-2.9 9.07-10.65 9.07-17.33 0-3.43-1.1-5.86-2.82-7.07l-23.851-13.95-11.226 25.38 22.917 13.29M1203.4 1881.02l-16.97 11.61 426.86 624 16.97-11.61-426.86-624",
    style: {
      fill: "#d8c4c3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.4 1791.97c0 61.26-37.24 132.43-83.19 158.95-11.61 6.71-25.4 10.15-36.34 10.12-8.59-.02-30.54-.85-53.31-14.93-26.17-16.18-29.7-52.93-29.7-52.93l93.46-191.97s30.1-14.78 61.02 2.15c19.24 10.54 30.85 27.95 36.14 37.6 2.33 4.22 5.84 12.74 6.89 15.95 3.25 9.97 5.03 21.71 5.03 35.06",
    style: {
      fill: "#2c1d1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.08 1866.31c0-61.26 37.24-132.43 83.18-158.95 45.95-26.53 83.19 1.63 83.19 62.89s-37.24 132.42-83.19 158.95c-45.94 26.52-83.18-1.63-83.18-62.89",
    style: {
      fill: "#422c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.88 1842.11c0-33.56 20.4-72.54 45.57-87.07 25.16-14.53 45.56.89 45.56 34.45s-20.4 72.54-45.56 87.07c-25.17 14.53-45.57-.89-45.57-34.45",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.9 1827.01c0-19.96 12.14-43.15 27.11-51.8 14.97-8.63 27.1.54 27.1 20.5s-12.13 43.14-27.1 51.79c-14.97 8.64-27.11-.53-27.11-20.49",
    style: {
      fill: "#422c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.16 1811.36c-7.43 26.04-11.81 70.21-10.71 108.35 1.08 38.12 14.24 58.7 64.87 50.38 40.8-6.71 89.83-51.93 106.84-107.55 7.43-24.25 9.54-29.89-26.28-44.26-28.95-11.62-120.73-55.92-134.72-6.92",
    style: {
      fill: "#c4b3b1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2260.83 1234.13c0 61.26-37.24 132.43-83.19 158.95-11.61 6.71-25.39 10.14-36.34 10.12-8.59-.02-30.54-.86-53.31-14.93-26.18-16.18-29.7-52.94-29.7-52.94l93.46-191.97s30.1-14.76 61.02 2.16c19.24 10.54 30.85 27.95 36.14 37.59 2.32 4.23 5.83 12.75 6.89 15.96 3.25 9.97 5.03 21.71 5.03 35.06",
    style: {
      fill: "#2c1d1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2055.51 1308.47c0-61.26 37.25-132.43 83.19-158.95 45.94-26.53 83.18 1.63 83.18 62.89s-37.24 132.42-83.18 158.95c-45.94 26.52-83.19-1.63-83.19-62.89",
    style: {
      fill: "#422c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2087.31 1284.27c0-33.56 20.4-72.54 45.57-87.07 25.17-14.53 45.56.89 45.56 34.45s-20.39 72.54-45.56 87.07c-25.17 14.53-45.57-.89-45.57-34.45",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2095.33 1269.17c0-19.96 12.13-43.15 27.1-51.8 14.97-8.63 27.11.54 27.11 20.5s-12.14 43.14-27.11 51.78c-14.97 8.65-27.1-.53-27.1-20.48",
    style: {
      fill: "#422c2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2100.58 1253.52c-7.42 26.04-11.8 70.21-10.71 108.34 1.09 38.13 14.24 58.71 64.89 50.39 40.79-6.71 89.81-51.93 106.83-107.55 7.43-24.25 9.53-29.9-26.29-44.26-28.94-11.62-120.73-55.93-134.72-6.92",
    style: {
      fill: "#c4b3b1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3205.31 1999.31c-8.43 21.76-9.39 99.02-30.75 124.73-21.36 25.69-37.28-1.49-33.8-21.09 3.48-19.6 23.71-127.82 23.71-127.82l40.84 24.18",
    style: {
      fill: "#2c1d1b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3289.96 1941.8c-32.11 29.43-55.99 75.05-93.08 79.27l-.49-.02c-52.92 5.6-95.18-54.62-119.35-93.18-63.83-101.86-98.54-281.46 18.85-360.73 94.59-63.88 255.85-10.06 307.84 87.68 1.14 2.14 2.96 3.98 4 6.17 48.68 103.04-36.46 206.3-117.77 280.81",
    style: {
      fill: "#ffcf48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3131.36 1727.69c53.24-93.53 156.64-122.45 272.37-72.87 1.14 2.14 2.96 3.98 4 6.17 48.68 103.04-36.46 206.3-117.77 280.81-32.12 29.43-55.99 75.05-93.08 79.27l-.49-.02c-60.54-74.32-115.55-204.61-65.03-293.36",
    style: {
      fill: "#fcbd0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3077.04 1927.87c-63.83-101.86-98.54-281.46 18.86-360.73 94.58-63.88 255.84-10.06 307.83 87.68-115.73-49.58-219.13-20.66-272.37 72.87-50.52 88.75 4.49 219.04 65.03 293.36-52.92 5.6-95.18-54.62-119.35-93.18",
    style: {
      fill: "#fcbd0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3365.14 1813.96c-18.95 51.87-106.55 82.21-149.49 48.8-73.68-57.34 21.27-157.6 90.13-156.49 37.07.6 82.55 44.19 59.36 107.69",
    style: {
      fill: "#ffdd92",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3334.11 1833.35c-5.58 15.27-31.34 24.18-43.97 14.36-21.68-16.87 6.25-46.37 26.51-46.04 10.9.18 24.28 13 17.46 31.68",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3838.6 1342.4-113.79-26.3-239.97 138.54c-60.25 34.78-152.23 38.6-204.4 8.48l-465.33-268.66-123.91 28.64s18.84-82.72 29.9-125.11l.02-.03c4.31-19.93 20.56-40.04 48.56-56.21l273.65-158c60.24-34.781 152.22-38.59 204.4-8.469l525.43 303.359c13.87 8.01 23.46 17.67 29.12 28.14 2.41 3.48 4.42 7.21 5.51 11.41 11.06 42.38 30.81 124.21 30.81 124.21",
    style: {
      fill: "#c6aaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3266.98 973.48c-64.31-37.128-177.05-32.46-251.32 10.418l-288.4 166.512c-74.26 42.87-82.36 107.96-18.04 145.09l553.76 319.72c64.32 37.14 177.06 32.46 251.32-10.41l288.4-166.52c74.27-42.87 82.37-107.96 18.05-145.1l-553.77-319.71",
    style: {
      fill: "#eeded9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3801.51 1304.3-553.77-319.718c-54.98-31.742-151.92-27.723-215.42 8.93l-288.4 166.508c-63.5 36.66-70.45 92.63-15.47 124.37l553.77 319.72c54.98 31.75 151.92 27.73 215.42-8.92l288.4-166.52c63.49-36.66 70.46-92.62 15.47-124.37",
    style: {
      fill: "#d7c3be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2969.95 1328.59c-1.36 10.42-10.37 17.45-19.51 18.03-15.01 22.63-49.91 26.81-75.21 13.73-41.43-21.41-69.19-80.56-52.99-125.03 12.24-33.56 64.23-84.07 103.57-72.67 24.67 7.15 24.85 38.75 29.06 59.84 6.71 33.52 19.51 72.04 15.08 106.1M3422.62 1779.79c-48.7-6.33-92.3-21.87-131.06-52.77-32.74-26.1-71.17-67.94-71.38-112.5-.02-4.58 5.9-7.12 9.14-3.78 13.72 14.16 24.81 29.86 36.55 45.02 5.87-3.31 13.37-4.3 21.9-.38 24.8 11.39 47.11 20.85 74.53 24.1 15.64 1.85 31.39 1.58 45.59 9.56 25.26 14.21 37.76 42.45 35.02 70.46-.96 9.8-8.58 21.8-20.29 20.29",
    style: {
      fill: "#ff7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3724.74 1500.51c-24.71 55.98-67 104.14-118.14 141.22 23.81-39.69 35.63-86.35 28.24-138.12-28.25-198.03-291-329.03-469.32-358.61-140.01-23.22-253.83 67.85-251.33 188.01-29.54-64.29-40.78-133.77-10.73-203.54 46.88-108.82 154.09-159.9 264.61-146.13 123.32 15.371 323.15 139.5 463.18 222.67 110.6 65.68 151.53 163.03 93.49 294.5",
    style: {
      fill: "#ff9c9c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3165.52 1145c178.32 29.58 441.07 160.58 469.32 358.61 7.39 51.77-4.43 98.43-28.24 138.12-123 89.19-298.41 112.71-412.4 15.34-57.85-49.41-118.47-105.84-164.59-158.05-42.09-47.63-87.14-104.45-115.42-166.01-2.5-120.16 111.32-211.23 251.33-188.01",
    style: {
      fill: "#ffabab",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3869.34 1507.23c-64.69 35.04-142.39-79.25-189.78-126.71-72.57 43.68-158 28.4-211.25-30.25-47.91-52.77-102.61-176.33-24.31-253.71 67.38 38.37 193.02 118.33 278.35 158.59 68.39 51.61 107.4 143.81 157.52 211.94 9.19 12.5 2.3 33.2-10.53 40.14M3367.89 1124.91c-14.55 0-45.15-9.66-59.27-11.76-30.17 56.21-118.67 51.44-158.37 6.69-42.45-47.85-12.75-121.969 48.65-138.699 37.47-10.219 60.49 12.48 93.11 28.999 23.61 11.97 109.15 62.53 124.49 71.38 7.13 24.97-11.88 43.39-48.61 43.39",
    style: {
      fill: "#ff7d7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3890.99 1402.23-39.52 22.67c9.25 14.66 18.61 28.88 28.4 42.19 9.19 12.5 2.3 33.2-10.53 40.14-8.37 4.54-16.97 6.57-25.68 6.57-25.41 0-51.87-17.28-77.07-40.23l-40.15 23.03c-.56 1.3-1.12 2.61-1.7 3.91-24.71 55.98-67 104.14-118.14 141.22 16.77-27.95 27.59-59.35 29.94-93.57-2.35 34.22-13.17 65.62-29.94 93.57-51.25 37.17-111.61 62.93-172.83 73.29 7.47 13.26 10.66 28.91 9.14 44.48-.91 9.23-7.72 20.42-18.3 20.42-.65 0-1.31-.05-1.99-.13-3.45-.45-6.87-.95-10.26-1.49-1.51 4.39-3.17 8.77-4.98 13.11 11.89-1.78 23.72-5.64 35.9-11.49 59.96-28.83 182.49-139.93 274.08-185.26 91.58-45.33 202-37.15 183.87-131.16-4.61-23.89-7.28-43.87-10.24-61.27",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3884.11 1370.74-27.68 15.88c-3.75 7.36-8.85 14.63-15.29 21.68 3.44 5.58 6.88 11.12 10.33 16.6l39.52-22.67c-1.96-11.49-4.04-21.86-6.88-31.49m-127.01 93.88-23.29 13.45c-2.23 6.1-4.69 12.28-7.37 18.53l40.15-23.03c-3.18-2.89-6.35-5.89-9.49-8.95",
    style: {
      fill: "#7c6d6c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3877.9 1353.84-14.02 8.06c-.79 8.22-3.28 16.52-7.45 24.72l27.68-15.88c-1.73-5.88-3.76-11.49-6.21-16.9",
    style: {
      fill: "#8b7877",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2671.52 1257.68c1.42 3.16 2.65 5.07 2.89 5.43-1.06-1.79-2.02-3.6-2.89-5.43m40.82 39.63c79 67.31 238.3 189.96 362.99 286.1 6.13-5.67 12.81-11 20.08-15.94-23.68-23-46.07-46.11-65.8-68.45-10.28-11.64-20.74-23.82-31.09-36.49l-286.18-165.22m1132.52 14.34c14.47 15.05 20.73 32.46 19.02 50.25l14.02-8.06c-6.74-14.9-16.74-28.35-33.04-42.19",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3095.41 1567.47a171.31 171.31 0 0 1 0 0m100.6 91.13a176.805 176.805 0 0 1 0 0m216.35 119.7a219.895 219.895 0 0 0 0 0",
    style: {
      fill: "#ffdd7f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3196.01 1658.6c-4.25 2.67-8.39 5.53-12.42 8.57 25.08 19.58 44.43 34.92 55.49 44.21 4.47 3.75 8.84 7.37 13.13 10.86 7.13-4.16 14.5-7.63 21.91-10.27-4.78-4.46-9.52-9.2-14.09-14.18-22.76-9.68-44.29-22.64-64.02-39.19m174.62 110.06c.98 6.82 1.11 14.08.22 21.74 7.23 1.44 14.29 2.15 21.27 2.15 5.12 0 10.19-.38 15.26-1.14 1.81-4.34 3.47-8.72 4.98-13.11-14.37-2.29-28.27-5.45-41.73-9.64",
    style: {
      fill: "#fdd156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3095.41 1567.47a171.31 171.31 0 0 0-20.08 15.94c41.27 31.82 78.73 60.72 108.26 83.76 4.03-3.04 8.17-5.9 12.42-8.57-.61-.5-1.21-1.02-1.81-1.53-33.1-28.27-67.11-58.84-98.79-89.6",
    style: {
      fill: "#fdd156",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3274.12 1711.97c-7.41 2.64-14.78 6.11-21.91 10.27 48.35 39.32 85.25 61.52 118.64 68.16.89-7.66.76-14.92-.22-21.74-28.32-8.81-54.65-22.18-79.07-41.64-5.72-4.56-11.61-9.6-17.44-15.05",
    style: {
      fill: "#ffe7b3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3136.73 947.02c-112.29 0-195.76 76.95-265.71 120.39l144.64-83.512c40.63-23.457 92.77-35.476 142.2-35.476 1.86 0 3.7.008 5.55.047a248.028 248.028 0 0 0-26.68-1.449m-286.79 132.56c-.01 0-.02.01-.03.02-29.32 15.4-76.25 39.98-114.64 66.18l114.67-66.2",
    style: {
      fill: "#d7c4c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3157.86 948.422c-49.43 0-101.57 12.019-142.2 35.476l-144.64 83.512c-7.17 4.45-14.18 8.54-21.08 12.17l-114.67 66.2c-21.25 14.51-39.88 29.51-51.46 43.74-24.65 30.29-17.27 57.02-12.29 68.16.87 1.83 1.83 3.64 2.89 5.43.03.04.04.07.04.07 8.45 8.48 21.42 20.1 37.89 34.13l286.18 165.22c-10.52-12.87-20.92-26.25-30.91-40.05l-239.16-138.09c-54.98-31.74-48.03-87.71 15.47-124.37l288.4-166.508c34.75-20.063 79.51-30.34 121.93-30.34 35.1 0 68.6 7.039 93.49 21.41l44.24 25.548c.01 0 .02.01.03.01 23.61 11.97 109.15 62.53 124.49 71.38 75.27 40.54 150.97 86.61 214.42 124.29l40.85 23.59c17.82 9.59 34.88 18.34 50.58 25.75 4.89 3.69 9.64 7.59 14.25 11.67l64.91 37.48c37.45 21.62 46.16 54.48 27.86 84.81 3.93 6.42 7.85 12.83 11.77 19.19 6.44-7.05 11.54-14.32 15.29-21.68 4.17-8.2 6.66-16.5 7.45-24.72 1.71-17.79-4.55-35.2-19.02-50.25-11.17-9.48-25.29-19.13-43.33-29.55-72.32-41.75-250.89-144.86-450.11-259.87-84.44-48.75-112.93-65.242-186.59-73.609l-1.42-.152c-1.85-.039-3.69-.047-5.55-.047m587.12 503.958-3.5 2.02c-2.18 7.76-4.73 15.64-7.67 23.67l23.29-13.45c-4.09-3.98-8.13-8.08-12.12-12.24",
    style: {
      fill: "#f3e8e4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3154.25 963.172c-42.42 0-87.18 10.277-121.93 30.34l-288.4 166.508c-63.5 36.66-70.45 92.63-15.47 124.37l239.16 138.09c-13.72-18.98-26.66-38.77-38.03-59.21-7.23 2.98-15.29 4.45-23.47 4.45-10.61 0-21.42-2.48-30.88-7.37-41.43-21.41-69.19-80.56-52.99-125.03 8.86-24.29 38.56-57.47 69.2-69.62 2.85-12.05 6.82-24.13 12.02-36.23 41.87-97.2 131.88-148.329 229.39-148.329 11.66 0 23.42.73 35.22 2.199 5.54.691 11.23 1.601 17.07 2.719a92.818 92.818 0 0 1 13.76-4.918c6.48-1.77 12.53-2.551 18.26-2.551 27.45 0 47.86 17.879 74.82 31.54l-44.24-25.548c-24.89-14.371-58.39-21.41-93.49-21.41m476.67 242.638c.11.07.22.13.33.2a368.7 368.7 0 0 1 15 9.39c8.63 4.81 17.16 9.5 25.52 14l-40.85-23.59m105.68 61.01c37.14 32.94 65.47 77.84 92.77 122.29 18.3-30.33 9.59-63.19-27.86-84.81l-64.91-37.48m6.08 183.16c-.39 1.47-.79 2.94-1.2 4.42l3.5-2.02c-.77-.8-1.53-1.59-2.3-2.4",
    style: {
      fill: "#e3d5d2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2891.44 1165.7c-30.64 12.15-60.34 45.33-69.2 69.62-16.2 44.47 11.56 103.62 52.99 125.03 9.46 4.89 20.27 7.37 30.88 7.37 8.18 0 16.24-1.47 23.47-4.45-5.53-9.94-10.69-20.03-15.39-30.26-24.42-53.15-36.33-109.84-22.75-167.31",
    style: {
      fill: "#ffa4a4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3122.04 1141.37c-70.44.01-130.91 29.34-168.19 75.47h.01c37.27-46.12 97.75-75.46 168.18-75.47",
    style: {
      fill: "#e3d5d2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2953.85 1216.84c-25.49 31.54-40.13 70.94-39.69 114.19-.44-43.25 14.2-82.64 39.7-114.19h-.01M3260.03 1697.79c4.57 4.98 9.31 9.72 14.09 14.18 5.83 5.45 11.72 10.49 17.44 15.05 24.42 19.46 50.75 32.83 79.07 41.64 13.46 4.19 27.36 7.35 41.73 9.64 3.39.54 6.81 1.04 10.26 1.49.68.08 1.34.13 1.99.13 10.58 0 17.39-11.19 18.3-20.42 1.52-15.57-1.67-31.22-9.14-44.48-19.77 3.35-39.64 5.09-59.31 5.09-39.66 0-78.56-7.07-114.43-22.32",
    style: {
      fill: "#ffa4a4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3132.85 981.141c-97.51 0-187.52 51.129-229.39 148.329-5.2 12.1-9.17 24.18-12.02 36.23-13.58 57.47-1.67 114.16 22.75 167.31l-.03-1.98c-.44-43.25 14.2-82.65 39.69-114.19 37.28-46.13 97.75-75.46 168.19-75.47h.05c13.83 0 28.03 1.13 42.53 3.48.15.03.31.05.47.08.14.02.28.05.43.07 74.11 12.29 162.78 42.09 243.16 86.95-9.67-46.96-3.64-96.89 35.32-135.39 49.16 28 129.35 78.14 202.25 118.84a368.7 368.7 0 0 0-15-9.39c-.11-.07-.22-.13-.33-.2-63.45-37.68-139.15-83.75-214.42-124.29 7.12 24.97-11.88 43.39-48.61 43.39-14.55 0-45.15-9.66-59.27-11.76-15.23 28.37-45.32 41.21-76.49 41.21-30.59 0-62.21-12.36-81.88-34.52-39.14-44.12-16.94-110.57 34.89-133.781a265.944 265.944 0 0 0-17.07-2.719 285.08 285.08 0 0 0-35.22-2.199m546.71 399.379c-25.63 15.42-52.87 23.5-79.71 24.9 17.77 30.53 30.01 63.32 34.99 98.19 1.47 10.31 2.18 20.42 2.18 30.31.01 4.8-.16 9.55-.48 14.24-2.35 34.22-13.17 65.62-29.94 93.57 51.14-37.08 93.43-85.24 118.14-141.22.58-1.3 1.14-2.61 1.7-3.91 2.68-6.25 5.14-12.43 7.37-18.53 2.94-8.03 5.49-15.91 7.67-23.67.41-1.48.81-2.95 1.2-4.42-23.74-24.99-45.52-51.83-63.12-69.46",
    style: {
      fill: "#ffbaba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3122.09 1141.37h-.05c-70.43.01-130.91 29.35-168.18 75.47-25.5 31.55-40.14 70.94-39.7 114.19l.03 1.98c4.7 10.23 9.86 20.32 15.39 30.26 11.37 20.44 24.31 40.23 38.03 59.21 9.99 13.8 20.39 27.18 30.91 40.05 10.35 12.67 20.81 24.85 31.09 36.49 19.73 22.34 42.12 45.45 65.8 68.45 31.68 30.76 65.69 61.33 98.79 89.6.6.51 1.2 1.03 1.81 1.53 19.73 16.55 41.26 29.51 64.02 39.19 35.87 15.25 74.77 22.32 114.43 22.32 19.67 0 39.54-1.74 59.31-5.09 61.22-10.36 121.58-36.12 172.83-73.29 16.77-27.95 27.59-59.35 29.94-93.57.32-4.69.49-9.44.48-14.24 0-9.89-.71-20-2.18-30.31-4.98-34.87-17.22-67.66-34.99-98.19-2.85.15-5.69.23-8.53.23-46.16 0-90.56-19.64-123.01-55.38-24.07-26.52-49.86-70.9-59.63-118.32-80.38-44.86-169.05-74.66-243.16-86.95-.15-.02-.29-.05-.43-.07-.16-.03-.32-.05-.47-.08-14.5-2.35-28.7-3.48-42.53-3.48",
    style: {
      fill: "#ffc4c4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3444 1096.56c-38.96 38.5-44.99 88.43-35.32 135.39 9.77 47.42 35.56 91.8 59.63 118.32 32.45 35.74 76.85 55.38 123.01 55.38 2.84 0 5.68-.08 8.53-.23 26.84-1.4 54.08-9.48 79.71-24.9 17.6 17.63 39.38 44.47 63.12 69.46.77.81 1.53 1.6 2.3 2.4 3.99 4.16 8.03 8.26 12.12 12.24 3.14 3.06 6.31 6.06 9.49 8.95 25.2 22.95 51.66 40.23 77.07 40.23 8.71 0 17.31-2.03 25.68-6.57 12.83-6.94 19.72-27.64 10.53-40.14-9.79-13.31-19.15-27.53-28.4-42.19-3.45-5.48-6.89-11.02-10.33-16.6-3.92-6.36-7.84-12.77-11.77-19.19-27.3-44.45-55.63-89.35-92.77-122.29-4.61-4.08-9.36-7.98-14.25-11.67-15.7-7.41-32.76-16.16-50.58-25.75-8.36-4.5-16.89-9.19-25.52-14-72.9-40.7-153.09-90.84-202.25-118.84M3217.16 978.59c-5.73 0-11.78.781-18.26 2.551a92.818 92.818 0 0 0-13.76 4.918c-51.83 23.211-74.03 89.661-34.89 133.781 19.67 22.16 51.29 34.52 81.88 34.52 31.17 0 61.26-12.84 76.49-41.21 14.12 2.1 44.72 11.76 59.27 11.76 36.73 0 55.73-18.42 48.61-43.39-15.34-8.85-100.88-59.41-124.49-71.38-.01 0-.02-.01-.03-.01-26.96-13.661-47.37-31.54-74.82-31.54",
    style: {
      fill: "#ffa4a4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3359.95 1598.16s-16.53-20.42-26.06-50.37c-9.53-29.94-10.89-43.55-10.89-43.55s14.39 18.38 25.28 46.96c10.89 28.58 11.67 46.96 11.67 46.96M3341.47 1598.16s-30.8-19.06-56.91-44.24c-26.12-25.18-42.02-46.96-42.02-46.96s26.01 20.38 49.47 38.11c27.01 20.42 49.46 53.09 49.46 53.09M3420.42 1598.16s16.33-29.95 34.03-53.09c17.69-23.14 43.56-40.83 43.56-40.83s-19.06 32.67-38.79 55.81c-19.75 23.14-38.8 38.11-38.8 38.11M2737.12 1246.22s51.72 15.85 100.73 17.84c49 1.98 88.48 0 88.48 0s-50.37-15.88-94.61-17.84c-44.23-1.96-94.6 0-94.6 0M3609.08 1317.26s49.5 21.82 97.93 29.54c48.43 7.73 87.87 10.4 87.87 10.4s-48.15-21.67-91.85-28.82c-43.7-7.15-93.95-11.12-93.95-11.12M2737.12 1205.1s39.48-19.37 94.6-27.53c55.13-8.18 87.18 0 87.18 0s-54.94 18.04-93.85 22.62c-38.93 4.6-87.93 4.91-87.93 4.91M3604.88 1411.69s39.48-19.37 94.6-27.54c55.13-8.16 87.19 0 87.19 0s-54.94 18.05-93.86 22.63c-38.92 4.6-87.93 4.91-87.93 4.91",
    style: {
      fill: "#c6aaa5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3179.39 1290.53-187.72-179.75 138.67-85.03 191.88 174.75-142.83 90.03",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3174.15 1267.88-154.89-148.32 113.51-70.99 159.24 145.02-117.86 74.29",
    style: {
      fill: "#442e2c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640.75 1135c8.87-53.05-17.35-112.3-61.64-147.641-72.78-58.07-190.6-19.437-221.96 65.841-1.1 3-1.72 6.09-2.54 9.14-.66-11.78-.35-23.91 2.15-36.44 23.05-115.111 177.79-152.22 259.09-86.841 63.59 51.132 66.58 136.981 24.9 195.941",
    style: {
      fill: "#ff5e33",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2579.11 987.359c44.29 35.341 70.51 94.591 61.64 147.641-15.8 22.35-37.8 40.96-65.66 52.18-56.4 22.71-131.32 24.56-177.08-21.22-16.55-16.56-40.75-56.19-43.4-103.62.82-3.05 1.44-6.14 2.54-9.14 31.36-85.278 149.18-123.911 221.96-65.841",
    style: {
      fill: "#ff8048",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2558.56 1166.08c-.95-4.72-12.19-6.46-25.11-3.87s-22.64 8.53-21.69 13.26c.95 4.72 12.2 6.45 25.12 3.86 12.92-2.59 22.63-8.52 21.68-13.25",
    style: {
      fill: "#604047",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2408.77 1115.36c1.6 2.1-1.45 4.78-3.5 3.51-9.12-5.69-15.5-12.7-18.48-23.27-2.55-9.08-2.52-23.83 6.92-28.72 3.4-1.76 6.6.5 7.03 4.04.5 4.16-.98 6.54-1.88 10.56-1 4.51-.91 9.39.06 13.89 1.51 7.09 5.47 14.27 9.85 19.99M2446.22 1053.8c-8.48 6.9-21.06 10.36-22.67 23.27-.26 2.08-2.93 2.58-3.69.5-3.11-8.41-2.84-16.25 2.73-23.74 4.37-5.87 15.31-14.28 23.3-11.18 6.01 2.34 4.48 7.76.33 11.15M2601.42 1125.27c-1.83.82-3.88-.14-3.96-2.28-.34-7.68 4.05-14.83 4.27-22.66.26-9.17-4-16-5.64-24.59-.95-4.98 4.54-8.34 8.43-4.91 12.06 10.66 13.57 46.92-3.1 54.44M2576.54 1064.86c-1.16 2.06-4.2.64-3.7-1.56 2.04-9.25 1.34-17.81-1.21-26.89-1.79-6.4-6.45-12.15-4.29-18.81.75-2.33 3.03-3.69 5.46-3.1 8.88 2.18 10.77 13.79 11.29 21.78.64 10.04-2.64 19.94-7.55 28.58M2474.23 1009.44c-7.37 2.54-13.17-2.72-20.07-4.91-8.4-2.66-15.04-1.2-23.19 1.21-3.69 1.09-5.96-2.93-4.59-5.97 4.18-9.278 15.58-12.258 25.02-11.399 9.24.848 23.7 4.688 26.46 14.679.78 2.84-.97 5.48-3.63 6.39M2477.99 1153.95c-4.53 6.08-3.25 10.74-3.95 17.62-.13 1.17-.88 2.05-2.12 2.11-20.2.92-10.65-42.21 10.21-37.87 2.03.42 3.85 2.77 3.71 4.87-.45 6.36-4.16 8.32-7.85 13.27",
    style: {
      fill: "#ff5e33",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2439.39 1112.31c-7.35 2.09-10.09 8.51-16.74 10.97l-1.79-.73c-5.39-11.43 7.3-23.47 18.53-21.44 5.87 1.05 5.18 9.72 0 11.2M2487.19 1120.94c-.74 1.13-2.54 1.3-3.25 0-2.67-4.98-6.75-9.15-8.59-14.42-1.11-3.18 2.2-5.51 5-5 8.38 1.53 11.28 12.72 6.84 19.42M2468.81 1080.31c-6.85-.39-12.71-3.1-19.81-2.19l-1.16-1.53c1.77-11.64 20.14-14.94 25.58-4.32 1.74 3.38-.33 8.29-4.61 8.04",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2897.13 976.789c8.88-53.051-17.35-112.301-61.64-147.641-72.78-58.066-190.6-19.437-221.96 65.84-1.1 3.004-1.72 6.094-2.54 9.141-.65-11.777-.35-23.91 2.15-36.438 23.05-115.109 177.79-152.211 259.1-86.832 63.58 51.121 66.57 136.961 24.89 195.93",
    style: {
      fill: "#ff5e33",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2835.49 829.148c44.29 35.34 70.52 94.59 61.64 147.641-15.79 22.352-37.8 40.961-65.65 52.181-56.41 22.71-131.33 24.56-177.09-21.22-16.54-16.551-40.75-56.191-43.4-103.621.82-3.047 1.44-6.137 2.54-9.141 31.36-85.277 149.18-123.906 221.96-65.84",
    style: {
      fill: "#ff8048",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2814.95 1007.87c-.95-4.73-12.2-6.46-25.12-3.87-12.92 2.59-22.63 8.53-21.68 13.26.95 4.72 12.19 6.45 25.11 3.86 12.92-2.59 22.63-8.52 21.69-13.25",
    style: {
      fill: "#604047",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665.15 957.148c1.6 2.094-1.45 4.782-3.5 3.512-9.12-5.68-15.49-12.699-18.48-23.281-2.55-9.07-2.51-23.828 6.93-28.707 3.4-1.75 6.59.508 7.02 4.039.5 4.16-.98 6.531-1.88 10.559-1 4.519-.91 9.39.06 13.89 1.52 7.09 5.47 14.27 9.85 19.988M2702.6 895.59c-8.47 6.898-21.06 10.359-22.67 23.281-.26 2.07-2.92 2.57-3.69.488-3.11-8.41-2.84-16.25 2.74-23.73 4.36-5.879 15.3-14.289 23.29-11.188 6.01 2.34 4.48 7.758.33 11.149M2857.8 967.059c-1.83.82-3.87-.137-3.96-2.278-.34-7.679 4.05-14.832 4.27-22.66.26-9.18-4-16-5.64-24.59-.95-4.98 4.55-8.34 8.43-4.91 12.07 10.66 13.57 46.918-3.1 54.438M2832.93 906.648c-1.17 2.063-4.21.641-3.71-1.566 2.04-9.242 1.34-17.801-1.2-26.871-1.8-6.41-6.46-12.16-4.3-18.82.76-2.332 3.04-3.692 5.46-3.102 8.89 2.18 10.77 13.781 11.29 21.781.64 10.032-2.64 19.942-7.54 28.578M2730.61 851.238c-7.37 2.532-13.17-2.738-20.07-4.918-8.4-2.648-15.04-1.199-23.19 1.211-3.69 1.09-5.96-2.922-4.59-5.972 4.19-9.27 15.59-12.258 25.02-11.387 9.25.84 23.7 4.68 26.46 14.68.78 2.82-.97 5.468-3.63 6.386M2734.37 995.738c-4.53 6.082-3.25 10.742-3.95 17.622-.13 1.17-.88 2.05-2.11 2.11-20.2.92-10.65-42.208 10.21-37.868 2.03.418 3.84 2.777 3.7 4.867-.45 6.371-4.16 8.32-7.85 13.269",
    style: {
      fill: "#ff5e33",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2695.77 954.102c-7.35 2.089-10.08 8.507-16.74 10.968l-1.78-.73c-5.4-11.43 7.29-23.469 18.52-21.449 5.87 1.07 5.18 9.73 0 11.211M2743.57 962.73c-.74 1.122-2.54 1.309-3.24 0-2.68-4.968-6.75-9.148-8.6-14.421-1.11-3.18 2.2-5.52 5-5 8.39 1.531 11.28 12.722 6.84 19.421M2725.19 922.102c-6.85-.403-12.71-3.102-19.81-2.192l-1.15-1.531c1.76-11.637 20.13-14.938 25.58-4.32 1.73 3.39-.34 8.293-4.62 8.043",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3650.64 1931.48c-8.88 0-16.07 7.19-16.07 16.06v1003.94c0 8.88 7.19 16.06 16.07 16.06 8.88 0 16.06-7.18 16.06-16.06V1947.54c0-8.87-7.18-16.06-16.06-16.06",
    style: {
      fill: "#e5d5d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4304.32 2708.8c0 127.97-78.52 278-174.49 333.41l-780.24 450.47c-44.02 25.42-84.25 26.44-115.03 8.02l-95.07-55.31 36.09-72.18c-.18-4.13-.49-8.15-.49-12.44 0-127.97 78.52-278 174.5-333.41l780.24-450.47 29.28-59.04 79.99 47.69c2.98 1.49 5.81 3.31 8.64 5.15l2.41 1.44c33.28 23.22 54.17 70.81 54.17 136.67",
    style: {
      fill: "#dd1e10",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4040.64 2523.77-780.24 450.47c-95.97 55.41-174.5 205.44-174.5 333.4 0 127.97 78.53 187.33 174.5 131.93l780.24-450.48c95.97-55.41 174.5-205.44 174.5-333.41 0-127.96-78.53-187.32-174.5-131.91",
    style: {
      fill: "#701b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3404.96 3115.79c0 40.39-13.05 72.13-33.82 84.14-20.75 11.97-33.83-4.7-33.83-45.09 0-40.72 13.08-74.03 33.83-86.01 20.77-12.01 33.82 6.24 33.82 46.96zm-102.86 59.38c0 66.16 27.99 87.91 69.04 64.23 41.04-23.72 69.07-78.11 69.07-143.97 0-66.16-28.03-89.76-69.07-66.07-41.05 23.72-69.04 79.62-69.04 145.81M3520.78 3056.05c17.98-10.37 27.76-5.77 27.76 14.11 0 19.89-9.78 32.37-27.76 42.74l-17.74 10.26v-56.86zm-52.01 123.25 54.83-31.65c32.16-18.58 58.52-48.71 58.52-96.86 0-29.84-10.73-42.59-27.04-42.8l34.5-101.02-38.49 22.23-29.15 89.85-18.9 10.9v-73.02l-34.27 19.79v202.58M3652.47 2907.65c25.89-14.95 43.13-8.14 43.13 40.33 0 48.45-17.24 73.33-43.13 88.27l-6.54 3.78v-128.6zm-40.83 189.14 42.91-24.75c46.43-26.81 76.3-74.81 76.3-144.42 0-69.57-29.87-84.96-74.42-59.23l-44.79 25.86v202.54M3759.65 3011.35l95.16-54.93v-38.54l-60.9 35.16v-40.69l51.81-29.9v-38.22l-51.81 29.9v-46.6l63.22-36.5v-38.52l-97.48 56.29v202.55M3939.39 2814.36c17.98-10.37 27.76-5.77 27.76 14.12 0 19.88-9.78 32.36-27.76 42.74l-17.71 10.25v-56.86zm-52.01 123.25 54.84-31.65c32.16-18.58 58.52-48.71 58.52-96.86 0-29.84-10.73-42.59-27.05-42.8l34.51-101.02-38.49 22.23-29.16 89.85-18.87 10.9v-73.02l-34.3 19.8v202.57",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3570.04 1927.88c1.37-61.21 38.58-133.15 83.09-160.68 44.52-27.54 79.48-.24 78.11 60.97-1.38 61.2-38.58 133.14-83.1 160.67-44.51 27.54-79.48.25-78.1-60.96",
    style: {
      fill: "#701b8c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3609.66 1903.37c.7-31.12 19.62-67.69 42.24-81.69 22.64-14 40.41-.12 39.72 30.99-.71 31.12-19.62 67.7-42.25 81.69-22.63 14-40.41.13-39.71-30.99",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 0 566.667)"
  }));
};
export default SvgSearchIlustration;